import { DashboardRouteNames, analyticsRouteNames, automationRouteNames, blogsRouteNames, businessRouteNames, calendarRouteNames, contactRouteNames, contactsRouteNames, conversationAIRouteNames, integrationsRouteNames, knowledgeBaseRouteNames, launchPadRouteNames, locationSettingsRouteNames, mobileAppRouteNames, opportunitiesRouteNames, reportingRouteNames, seoRouteNames, tasksRouteNames } from '@/routes/constants/location'
import { FEATURE_CONTROLLED_COMPANY_ID, LC_INTEGRATIONS_COMPANY_ID } from './constants'
import { ProductRouteNames, ordersRouteNames, reputationRouteNames, subscriptionsRouteNames, transactionsRouteNames } from '../routes/constants/location'
import { affiliatePortalRoutes, agencyDashboardRoutes, agencyLaunchpadRoutes, ghlSwagRoutes, ideasRoutes, integrationRoutes, marketplaceRoutes, mobileAppCustomiserRoutes, partnersRoutes, prospectingRoutes, resellingRoutes, saasRoutes, settingsRoutes, snapshotsRoutes, subAccountRoutes, templateLibraryAdminRoutes, universityRoutes } from '@/routes/constants/agency/'
import { agencyNavigation as agencyNavigationConfig, locationNavigation as locationNavigationConfig, SideBarItemConfig, Scopes, Permissions} from '@/config/navigation/'

import { LOCATION_SETTING_CONFIG } from "./location_setting_config"
import { SOCIAL_PLANNER_NAVIGATION } from './socialPlanner/social_planner_routes'
import { i18n } from "../localization"
import { marketingRouteNames } from '../routes/constants/location/marketing'
import { membershipRouteNames } from '../routes/constants/location/membership'
import { voiceAIRouteNames } from '../routes/constants/location/voice-ai'


const locationNavigation: SideBarItemConfig[] = [
  ...locationNavigationConfig,
  {
    "name": "common.sidebar.dashboard",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "dashboard",
    "tooltip": "common.sidebar.dashboard",
    "permissions": {
      "all": [
        "dashboard_stats_enabled"
      ],
      "any": []
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/icon_dashboard.svg",
    "children": [],
    "route": {
      "name": DashboardRouteNames.default,
      "params": [
        "location_id"
      ]
    },
    "userScopes": {
      "any": [],
      "all": [
        "dashboard/stats.readonly"
      ]
    }
  },
  {
    "name": "common.sidebar.conversations",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "conversations",
    "tooltip": "common.sidebar.conversations",
    "permissions": {
      "all": [],
      "any": [
        "conversations_enabled",
        "contacts_enabled",
        "sms_email_templates_enabled",
        "marketing_enabled"
      ]
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/icon_conversations.svg",
    "children": [
      {
        "name": "common.sidebar.conversations",
        "meta": "conversations-tab",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "conversations_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "conversations-id-v2",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "conversations.write"
          ]
        }
      },
      {
        "name": "common.sidebar.manualActions",
        "meta": "manial-actions",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "contacts_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "manual-actions-v2",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "contacts.write"
          ]
        }
      },
      {
        "name": "common.sidebar.templatesSnippets",
        "meta": "conversations-templates",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "sms_email_templates_enabled",
            "marketing_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "conversations-templates-v2",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "marketing.write"
          ]
        }
      },
      {
        "name": "common.sidebar.triggerLinks",
        "meta": "trigger-links",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "trigger_links_enabled",
            "marketing_enabled"
          ],
          "any": []
        },
        "children": [],
        "items": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "triggers-links-conversations-v3",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "marketing.write"
          ]
        }
      }
    ],
    "route": {
      "name": "conversations-v2",
      "params": [
        "location_id"
      ]
    },
    "userScopes": {
      "any": [
        "conversations.write",
        "contacts.write",
        "marketing.write"
      ],
      "all": []
    }
  },
  {
    "name": "common.sidebar.calendars",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "calendars",
    "tooltip": "common.sidebar.calendars",
    "permissions": {
      "all": [
        "appointments_enabled"
      ],
      "any": []
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/icon_calendar.svg",
    "children": [
      {
        "name": "common.sidebar.calendar_view",
        "meta": "calendars-tab",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "appointments_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": calendarRouteNames.calendarPageV2,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "calendars.readonly",
            "calendars/events.readonly",
            "calendars/groups.readonly"
          ]
        }
      },
      {
        "name": "common.sidebar.appointment_list_view",
        "meta": "apppontment-tab",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "appointments_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": calendarRouteNames.appointmentList,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "calendars.readonly",
            "calendars/events.readonly",
            "calendars/groups.readonly"
          ]
        }
      },
      {
        "name": "",
        "meta": "appointment-divider",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "divider",
        "route": null,
        "userScopes": {
          "any": [],
          "all": [
            "settings.write"
          ]
        }
      },
      {
        "name": "common.sidebar.calendarSettings",
        "meta": "calendar-settings-top",
        "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/icon_settings.svg",
        "enabled": true,
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": null,
        "reference_route": {
          "name": locationSettingsRouteNames.calendars.default,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "settings.write"
          ]
        }
      }
    ],
    "route": {
      "name": "calendars-v2",
      "params": [
        "location_id"
      ]
    },
    "userScopes": {
      "any": [],
      "all": [
        "calendars.readonly",
        "calendars/events.readonly",
        "calendars/groups.readonly"
      ]
    }
  },
  {
    "name": "common.sidebar.contacts",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "contacts",
    "tooltip": "common.sidebar.contacts",
    "permissions": {
      "all": [],
      "any": [
        "contacts_enabled"
      ]
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/icon_contacts.svg",
    "children": [
      {
        "name": "common.sidebar.smartLists",
        "meta": "lists",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "contacts_enabled"
          ],
          "any": []
        },
        "items": [
          {
            "name": "Details",
            "meta": "contacts-details",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "contacts_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": contactsRouteNames.contactDetail,
              "params": [
                "location_id",
                "contact_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "contacts.write"
              ]
            }
          },
          {
            "name": "Import Filter",
            "meta": "import-filter",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "contacts_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": contactsRouteNames.importFilter,
              "params": [
                "location_id",
                "import_filter"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "contacts.write"
              ]
            }
          },
          {
            "name": "Business Filter",
            "meta": "Business-filter",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "contacts_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": contactsRouteNames.businessName,
              "params": [
                "location_id",
                "business_name"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "contacts.write"
              ]
            }
          }
        ],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": contactsRouteNames.smartList,
          "params": [
            "location_id"
          ],
          "default_params": {
            "smart_list": "All"
          }
        },
        "userScopes": {
          "any": [],
          "all": [
            "contacts.write"
          ]
        }
      },
      {
        "name": "common.sidebar.bulkActions",
        "meta": "bulk-actions",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "bulk_requests_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": contactsRouteNames.bulkActions,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "contacts/bulkActions.write"
          ]
        }
      },
      {
        "name": "common.sidebar.restore",
        "meta": "contacts-restore",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "contacts_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": contactsRouteNames.contactRestore,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "contacts.write"
          ]
        }
      },
      {
        "name": "common.sidebar.tasks",
        "meta": "tasks",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": tasksRouteNames.default,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.businesses",
        "meta": "business",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": businessRouteNames.default,
          "params": [
            "location_id",
            "business_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.manageSmartLists",
        "meta": "contacts-settings-top",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": locationSettingsRouteNames.smartList,
          "params": [
            "location_id"
          ],
          "default_params": {
            "smart_list": "Settings"
          }
        },
        "userScopes": {
          "any": [],
          "all": [
            "settings.write"
          ]
        }
      },
      {
        "name": "common.sidebar.contacts",
        "meta": "contacts-contacts",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "contacts_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "contacts-contacts-v2",
          "params": [
            "location_id"
          ]
        },
        "hide": true,
        "userScopes": {
          "any": [],
          "all": [
            "contacts.write"
          ]
        }
      },
      {
        "name": "common.sidebar.leads",
        "meta": "contacts-leads",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "contacts_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "leads-v2",
          "params": [
            "location_id"
          ]
        },
        "hide": true,
        "userScopes": {
          "any": [],
          "all": [
            "contacts.write"
          ]
        }
      },
      {
        "name": "",
        "meta": "contacts-divider",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": [
            "contacts_enabled",
            "marketing_enabled"
          ]
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "divider",
        "route": null,
        "userScopes": {
          "any": [
            "contacts.write",
            "marketing.write"
          ],
          "all": [
            "settings.write"
          ]
        }
      },
      {
        "name": "",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "contact-custom-fields-settings",
        "tooltip": "Custom Fields",
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": [
            "contacts_enabled",
            "marketing_enabled"
          ]
        },
        "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/icon_settings.svg",
        "children": [],
        "route": null,
        "reference_route": {
          "name": locationSettingsRouteNames.fields,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [
            "contacts.write",
            "marketing.write"
          ],
          "all": [
            "settings.write"
          ]
        }
      }
    ],
    "hideForCompanyId": FEATURE_CONTROLLED_COMPANY_ID,
    "route": {
      "name": contactsRouteNames.default,
      "params": [
        "location_id"
      ]
    },
    "userScopes": {
      "any": [
        "contacts.write"
      ],
      "all": []
    }
  },
  {
    "name": "common.sidebar.contact",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "contact",
    "tooltip": "common.sidebar.contact",
    "permissions": {
      "all": [],
      "any": [
        "contacts_enabled"
      ]
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/icon_contacts.svg",
    "children": [
      {
        "name": "common.sidebar.smartLists",
        "meta": "contact-lists",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "contacts_enabled"
          ],
          "any": []
        },
        "items": [
          {
            "name": "Details",
            "meta": "contact-details",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "contacts_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": contactRouteNames.specialCompanyDetail,
              "params": [
                "location_id",
                "contact_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "contacts.write"
              ]
            }
          }
        ],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": contactRouteNames.smartList,
          "params": [
            "location_id"
          ],
          "default_params": {
            "smart_list": "All"
          }
        },
        "userScopes": {
          "any": [],
          "all": [
            "contacts.write"
          ]
        }
      },
      {
        "name": "common.sidebar.bulkActions",
        "meta": "contact-bulk-actions",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "bulk_requests_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": contactRouteNames.bulkActions,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "contacts/bulkActions.write"
          ]
        }
      }
    ],
    "showOnlyForCompanyId": FEATURE_CONTROLLED_COMPANY_ID,
    "route": {
      "name": contactRouteNames.default,
      "params": [
        "location_id"
      ]
    },
    "userScopes": {
      "any": [
        "contacts.write"
      ],
      "all": []
    }
  },
  {
    "name": "common.sidebar.opportunities",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "opportunities",
    "tooltip": "common.sidebar.opportunities",
    "permissions": {
      "all": [
        "opportunities_enabled"
      ],
      "any": []
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/icon_opportunities.svg",
    "children": [
      {
        "name": "common.sidebar.opportunities",
        "meta": "opportunities-tab",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "opportunities_enabled"
          ],
          "any": []
        },
        "items": [
          {
            "name": "common.sidebar.opportunities",
            "meta": "opportunities-tab-by-id",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "opportunities_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": opportunitiesRouteNames.byId,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "opportunities.write"
              ]
            }
          }
        ],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": opportunitiesRouteNames.list,
          "params": [
            "location_id"
          ]
        },
        "children": [],
        "userScopes": {
          "any": [],
          "all": [
            "opportunities.write"
          ]
        }
      },
      {
        "name": "common.sidebar.pipelines",
        "meta": "pipeline",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": opportunitiesRouteNames.pipeline,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "settings.write"
          ]
        }
      },
      {
        "name": "common.sidebar.bulkActions",
        "meta": "bulk-actions",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "opportunities_bulk_actions_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": opportunitiesRouteNames.BulkActions,
          "params": [
            "location_id"
          ]
        },
        "labs": true,
        "userScopes": {
          "any": [],
          "all": [
            "opportunities/bulkActions.write"
          ]
        }
      }
    ],
    "route": {
      "name": opportunitiesRouteNames.default,
      "params": [
        "location_id"
      ]
    },
    "userScopes": {
      "any": [],
      "all": [
        "opportunities.write"
      ]
    }
  },
  {
    "name": "common.sidebar.payments",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "payments",
    "tooltip": "common.sidebar.payments",
    "permissions": {
      "all": [
        "payments_enabled"
      ],
      "any": []
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/icon_payments.svg",
    "children": [
      {
        "name": "common.payments.invoiceEstimatesHeader",
        "meta": "payment-invoices",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "payments_enabled",
            "invoice_enabled"
          ],
          "any": []
        },
        "items": [],
        "badge": {
          "enable": true,
          "title": "common.sidebar.new"
        },
        "children": [
          {
            "name": "common.sidebar.allInvoices",
            "meta": "payment-invoices",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled",
                "invoice_enabled"
              ],
              "any": []
            },
            "items": [
              {
                "name": "common.sidebar.invoiceSettings",
                "meta": "invoice-settings",
                "icon": null,
                "enabled": false,
                "permissions": {
                  "all": [
                    "payments_enabled",
                    "invoice_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "invoice-settings",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "payments.write",
                    "invoices.write"
                  ]
                }
              }
            ],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "payment-products-list-invoices",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments.write",
                "invoices.write"
              ]
            }
          },
          {
            "name": "common.payments.recurringInvoicesHeader",
            "meta": "payment-recurring-templates",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled",
                "invoice_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "payment-products-list-recurring-invoices",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments.write",
                "invoices.write"
              ]
            }
          },
          {
            "name": "common.sidebar.templates",
            "meta": "payment-invoice-templates",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled",
                "invoice_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "invoice-templates",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments.write",
                "invoices.write"
              ]
            }
          },
          {
            "name": "common.payments.estimatesHeading",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "estimates",
              "params": [
                "location_id"
              ]
            },
            "badge": {
              "enable": true,
              "title": "common.sidebar.new"
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments.write"
              ]
            }
          }
        ],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "payment-products-list-invoices",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "payments.write",
            "invoices.write"
          ]
        }
      },
      {
        "children": [
          {
            "name": "common.sidebar.allDocuments",
            "meta": "all-proposals-estimates",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled",
                "proposals_enabled"
              ],
              "any": []
            },
            "route": {
              "name": "proposals-estimates",
              "params": []
            },
            "children": [],
            "tooltip": null,
            "type": "header",
            "items": [],
            "userScopes": {
              "any": [],
              "all": [
                "payments.write"
              ]
            }
          },
          {
            "name": "common.sidebar.templates",
            "meta": "proposals-estimates",
            "icon": null,
            "enabled": false,
            "permissions": {
              "all": [
                "payments_enabled",
                "proposals_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "proposals-estimates-templates",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments.write"
              ]
            }
          }
        ],
        "name": "common.sidebar.documents",
        "meta": "proposals-estimates",
        "icon": null,
        "enabled": true,
        "tooltip": null,
        "type": "header",
        "permissions": {
          "all": [
            "payments_enabled",
            "proposals_enabled"
          ],
          "any": []
        },
        "route": {
          "name": "proposals-estimates",
          "params": []
        },
        "items": [
          {
            "name": "Proposals & Estimates",
            "meta": "proposals-estimates-settings",
            "icon": null,
            "enabled": true,
            "tooltip": null,
            "type": "header",
            "permissions": {
              "all": [
                "settings_enabled"
              ],
              "any": []
            },
            "route": {
              "name": "proposals-estimates-settings",
              "params": []
            },
            "items": [],
            "children": [],
            "userScopes": {
              "any": [],
              "all": [
                "settings.write"
              ]
            }
          },
          {
            "name": "Templates",
            "meta": "proposals-estimates",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled",
                "proposals_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "proposals-estimates-templates",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments.write"
              ]
            }
          }
        ],
        "userScopes": {
          "any": [],
          "all": [
            "payments.write"
          ]
        }
      },
      {
        "children": [
          {
            "name": "common.sidebar.orders",
            "meta": "all-payment-orders-new",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments/orders.readonly"
              ],
              "any": []
            },
            "route": {
              "name": ordersRouteNames.orders,
              "params": []
            },
            "children": [],
            "tooltip": null,
            "type": "header",
            "items": [
              {
                "name": "common.sidebar.details",
                "meta": "order-details-new",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "payments/orders.readonly"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": ordersRouteNames.orderDetails,
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "payments/orders.write"
                  ]
                }
              }
            ],
            "userScopes": {
              "any": [],
              "all": [
                "payments/orders.write"
              ]
            }
          },
          {
            "name": "common.sidebar.abandonedCheckouts",
            "meta": "all-abandoned-checkouts",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled"
              ],
              "any": []
            },
            "items": [
              {
                "name": "common.sidebar.abandonedCheckouts",
                "meta": "payments-abandoned_checkouts",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "payments_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "abandoned_checkouts-details",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "payments/orders.readonly"
                  ]
                }
              }
            ],
            "children": [],
            "tooltip": null,
            "type": "header",
            "badge": {
              "enable": true,
              "title": "common.sidebar.new"
            },
            "route": {
              "name": "abandoned_checkouts",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments.write"
              ]
            }
          }
        ],
        "name": "common.sidebar.orders",
        "meta": "payment-orders-new",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "payments/orders.readonly"
          ],
          "any": []
        },
        "items": [
          {
            "name": "common.sidebar.details",
            "meta": "order-details-new",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments/orders.readonly"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": ordersRouteNames.orderDetails,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments/orders.write"
              ]
            }
          },
          {
            "name": "common.sidebar.abandonedCheckouts",
            "meta": "all-abandoned-checkouts",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled"
              ],
              "any": []
            },
            "items": [
              {
                "name": "common.sidebar.abandonedCheckouts",
                "meta": "payments-abandoned_checkouts",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "payments_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "abandoned_checkouts-details",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "payments.write"
                  ]
                }
              }
            ],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "abandoned_checkouts",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments/orders.write"
              ]
            }
          }
        ],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": ordersRouteNames.orders,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "payments/orders.readonly"
          ]
        }
      },
      {
        "name": "common.sidebar.subscriptions",
        "meta": "payment-subscriptions",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "payments/subscriptions.readonly"
          ],
          "any": []
        },
        "items": [
          {
            "name": "common.sidebar.details",
            "meta": "subscription-details",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments/subscriptions.readonly"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": subscriptionsRouteNames.subscriptionDetails,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments/subscriptions.write"
              ]
            }
          }
        ],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": subscriptionsRouteNames.subscriptions,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "payments/subscriptions.write"
          ]
        }
      },
      {
        "name": "common.payments.paymentLinks",
        "meta": "payment-links",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "payments_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "payment-links",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "payments.write"
          ]
        }
      },
      {
        "name": "common.sidebar.transactions",
        "meta": "payment-transactions-new",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "payments/transactions.readonly"
          ],
          "any": []
        },
        "items": [
          {
            "name": "common.sidebar.details",
            "meta": "transaction-details-new",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments/transactions.readonly"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": transactionsRouteNames.transactionDetails,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments/transactions.readonly"
              ]
            }
          }
        ],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "transactions-v2-new",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "payments/transactions.readonly"
          ]
        }
      },
      {
        "name": "common.sidebar.products",
        "meta": "payments-products",
        "icon": null,
        "enabled": true,
        "badge": {
          "enable": true,
          "title": "common.sidebar.new"
        },
        "permissions": {
          "all": [
            "products.readonly"
          ],
          "any": []
        },
        "children": [
          {
            "name": i18n.t("common.sidebar.products"),
            "meta": "all-products",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "products.readonly"
              ],
              "any": []
            },
            "items": [
              {
                "name": i18n.t("common.sidebar.details"),
                "meta": "product-details",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "products.readonly"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": ProductRouteNames.details,
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "products.write"
                  ]
                }
              },
              {
                "name": i18n.t("common.sidebar.create"),
                "meta": "product-create",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "products.readonly"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": ProductRouteNames.create,
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "products.write"
                  ]
                }
              },
              {
                "name": i18n.t("common.sidebar.importStripeProduct"),
                "meta": "import-stripe-product",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "products.readonly", "products.write"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": ProductRouteNames.stripe,
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "products.write"
                  ]
                }
              },
              {
                "name": i18n.t("common.sidebar.edit"),
                "meta": "product-edit",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "products.readonly", "products.write"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": ProductRouteNames.edit,
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "products.write"
                  ]
                }
              },
              {
                "name": i18n.t("common.sidebar.product-inventory"),
                "meta": "product-inventory",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "payments_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": ProductRouteNames.inventoryHistory,
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "products.write"
                  ]
                }
              },
              {
                "name": i18n.t("common.sidebar.viewVariants"),
                "meta": "view-product-variants",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "products.readonly"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": ProductRouteNames.viewVariants,
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "products.write"
                  ]
                }
              }
            ],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": ProductRouteNames.products,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "products.write"
              ]
            }
          },
          {
            "name": i18n.t("common.sidebar.collections"),
            "meta": "all-collections",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "products.readonly"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "badge": {
              "enable": false,
              "title": "common.sidebar.new"
            },
            "route": {
              "name": ProductRouteNames.collections,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "products.write"
              ]
            }
          },
          {
            "name": i18n.t("common.sidebar.inventory"),
            "meta": "all-inventory",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "products.readonly"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": ProductRouteNames.inventory,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "products.write"
              ]
            }
          },
          {
            "name": i18n.t("common.sidebar.reviews"),
            "meta": "product-reviews",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "products.readonly"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "badge": {
              "enable": true,
              "title": "common.sidebar.new"
            },
            "route": {
              "name": ProductRouteNames.reviews,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "products.write"
              ]
            }
          }
        ],
        "items": [
          {
            "name": "common.sidebar.details",
            "meta": "product-details",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "products.readonly"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": ProductRouteNames.details,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "products.write"
              ]
            }
          },
          {
            "name": "common.sidebar.create",
            "meta": "product-create",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "products.readonly", "products.write"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": ProductRouteNames.create,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "products.write"
              ]
            }
          },
          {
            "name": "common.sidebar.importStripeProduct",
            "meta": "import-stripe-product",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "products.readonly", "products.write"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": ProductRouteNames.stripe,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "products.write"
              ]
            }
          },
          {
            "name": "common.sidebar.edit",
            "meta": "product-edit",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "products.readonly", "products.write"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": ProductRouteNames.edit,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "products.write"
              ]
            }
          },
          {
            "name": "common.sidebar.product-inventory",
            "meta": "product-inventory",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "products.readonly"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": ProductRouteNames.inventoryHistory,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "products.write"
              ]
            }
          },
          {
            "name": i18n.t("common.sidebar.viewVariants"),
            "meta": "view-product-variants",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "products.readonly"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": ProductRouteNames.viewVariants,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "products.write"
              ]
            }
          },
          {
            "name": i18n.t("common.sidebar.collections"),
            "meta": "all-collections",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": ProductRouteNames.collections,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "products.write"
              ]
            }
          },
          {
            "name": i18n.t("common.sidebar.inventory"),
            "meta": "all-inventory",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "badge": {
              "enable": true,
              "title": "common.sidebar.new"
            },
            "route": {
              "name": ProductRouteNames.inventory,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "products.write"
              ]
            }
          },
          {
            "name": i18n.t("common.sidebar.reviews"),
            "meta": "product-reviews",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "badge": {
              "enable": true,
              "title": "common.sidebar.new"
            },
            "route": {
              "name": ProductRouteNames.reviews,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "products.write"
              ]
            }
          }
        ],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": ProductRouteNames.products,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "products.write"
          ]
        }
      },
      {
        "name": "common.sidebar.coupons",
        "meta": "payments-coupons",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "payments_enabled"
          ],
          "any": []
        },
        "children": [],
        "items": [
          {
            "name": "common.sidebar.create",
            "meta": "create-coupon",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "create-coupon",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments.write"
              ]
            }
          },
          {
            "name": "common.sidebar.edit",
            "meta": "edit-coupon",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "edit-coupon",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments.write"
              ]
            }
          }
        ],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "coupons",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "payments.write"
          ]
        }
      },
      {
        "name": "common.sidebar.settings",
        "meta": "payment-settings",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "payments_enabled"
          ],
          "any": []
        },
        "items": [
          {
            "name": "common.sidebar.receiptSettings",
            "meta": "payment-settings-receipt",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "payment-settings-receipts",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments.write"
              ]
            }
          },
          {
            "name": "common.sidebar.taxSettings",
            "meta": "payment-settings-taxes",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "payment-settings-taxes",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments.write"
              ]
            }
          },
          {
            "name": "common.sidebar.notifications",
            "meta": "payment-settings-notifications",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "payment-settings-notifications",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments.write"
              ]
            }
          },
          {
            "name": "common.sidebar.shippingSettings",
            "meta": "payment-settings-shipping",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "payment-settings-shipping",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments.write"
              ]
            }
          },
          {
            "name": "common.sidebar.shippingOrigin",
            "meta": "payment-settings-shipping-origin",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "payment-settings-shipping-origin",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments.write"
              ]
            }
          },
          {
            "name": "common.sidebar.shippingOrigin",
            "meta": "payment-settings-subscriptions",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "payment-settings-subscriptions",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments.write"
              ]
            }
          },
          {
            "name": "common.sidebar.miscellaneousCharges",
            "meta": "payment-settings-misc-charges",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "payment-settings-misc-charges",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments.write"
              ]
            }
          },
          {
            "name": "common.sidebar.paymentLinks",
            "meta": "payment-settings-payment-links",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "payment-settings-payment-links",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments.write"
              ]
            }
          }
        ],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "payment-settings-receipts",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "payments.write"
          ]
        }
      },
      {
        "name": "common.sidebar.integrations",
        "meta": "payment-integrations",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "payments_enabled"
          ],
          "any": []
        },
        "items": [
          {
            "name": "Manage Payment Integrations",
            "meta": "manage-payment-integrations",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "manage-payment-integrations",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments.write"
              ]
            }
          },
          {
            "name": "All Payment Integrations",
            "meta": "all-payment-integrations",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "payments_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "all-payment-integrations",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "payments.write"
              ]
            }
          }
        ],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "payment-integrations-v2",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "payments.write"
          ]
        }
      }
    ],
    "route": {
      "name": "payments-v2",
      "params": [
        "location_id"
      ]
    },
    "userScopes": {
      "any": [],
      "all": [
        "payments.write"
      ]
    }
  },
  {
    "name": "",
    "enabled": true,
    "items": [],
    "children": [],
    "type": "divider",
    "meta": "divider-1",
    "icon": null,
    "tooltip": "",
    "route": {},
    "permissions": {
      "all": [],
      "any": []
    },
    "userScopes": {
      "any": [],
      "all": []
    }
  },
  {
    "name": "common.sidebar.marketing",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "email-marketing",
    "tooltip": "common.sidebar.marketingTooltip",
    "permissions": {
      "all": [],
      "any": [
        "email_builder_enabled",
        "sms_email_templates_enabled",
        "trigger_links_enabled",
        "html_builder_enabled",
        "social_planner",
        "marketing_enabled"
      ]
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/icon_emailmarketing.svg",
    "children": [
      SOCIAL_PLANNER_NAVIGATION,
      {
        "name": "common.sidebar.emails",
        "meta": "email-builder",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "email_builder_enabled",
            "marketing_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [
          {
            "name": "common.sidebar.statistics",
            "meta": "email-builder-statistics",
            "icon": null,
            "enabled": false,
            "permissions": {
              "all": [
                "email_builder_enabled",
                "marketing_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "emails_home-v2-statistics",
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "marketing.write"
              ]
            }
          },
          {
            "name": "common.sidebar.campaigns",
            "meta": "email-builder-campaigns",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "email_builder_enabled",
                "marketing_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "emails_home-v2-campaigns",
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "marketing.write"
              ]
            }
          },
          {
            "name": "common.sidebar.templates",
            "meta": "email-builder-templates",
            "icon": null,
            "enabled": false,
            "permissions": {
              "all": [
                "email_builder_enabled",
                "marketing_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "emails_home-v2-templates",
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "marketing.write"
              ]
            }
          },
          {
            "name": "common.sidebar.settings",
            "meta": "email-builder-settings",
            "icon": null,
            "enabled": false,
            "permissions": {
              "all": [
                "email_builder_enabled",
                "marketing_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "emails_home-v2-settings",
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "marketing.write"
              ]
            }
          },
          {
            "name": "common.sidebar.stats",
            "meta": "email-builder-stats",
            "icon": null,
            "enabled": false,
            "permissions": {
              "all": [
                "email_builder_enabled",
                "marketing_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "emails_home-v2-campaign-statistics",
              "params": [
                "location_id",
                "source",
                "sourceId"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "marketing.write"
              ]
            }
          }
        ],
        "tooltip": null,
        "route": {
          "name": "emails_home-v2-statistics",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "marketing.write"
          ]
        }
      },
      {
        "name": "common.sidebar.emailBuilder",
        "meta": "email-builder-details",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "email_builder_enabled",
            "marketing_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "route": {
          "name": "emails_home-detail-v2",
          "params": [
            "location_id",
            "path"
          ],
          "default_params": {
            "path": "all"
          }
        },
        "hide": true,
        "userScopes": {
          "any": [],
          "all": [
            "marketing.write"
          ]
        }
      },
      {
        "name": "common.sidebar.templatesSnippets",
        "meta": "email-templates",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "sms_email_templates_enabled",
            "marketing_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "templates-v2",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "marketing.write"
          ]
        }
      },
      {
        "name": "common.sidebar.countdownTimers",
        "meta": "countdown-timer",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "sms_email_templates_enabled",
            "marketing_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "countdown-timer-list-v2",
          "params": [
            "location_id"
          ]
        },
        "badge": {
          "enable": false,
          "title": "common.sidebar.new"
        },
        "userScopes": {
          "any": [],
          "all": [
            "marketing.write"
          ]
        }
      },
      {
        "name": "common.sidebar.triggerLinks",
        "meta": "trigger-links",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "trigger_links_enabled",
            "marketing_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "triggers-links-marketing-v3",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "marketing.write"
          ]
        }
      },
      {
        "name": "common.sidebar.affiliateManager",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "affiliate-manager",
        "tooltip": "common.sidebar.affiliateManager",
        "permissions": {
          "all": [
            "affiliate_manager_enabled"
          ],
          "any": []
        },
        "children": [
          {
            "name": "Onboarding",
            "meta": "onboarding-tab",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "affiliate_manager_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": 'affiliate-manager-onboarding-page-v2',
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "marketing/affiliate.write"
              ]
            }
          },
          {
            "name": "common.sidebar.dashboard",
            "meta": "dashboard-tab",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "affiliate_manager_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "affiliate-manager-dashboard-page-v2",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "marketing/affiliate.write"
              ]
            }
          },
          {
            "name": "common.sidebar.campaigns",
            "meta": "campaigns",
            "type": "header",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "affiliate_manager_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [
              {
                "name": "Campaign",
                "meta": "campaign-tab",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "affiliate_manager_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "affiliate-manager-campaign-page-v2",
                  "params": [
                    "location_id"
                  ]
                },
                "children": [],
                "hide": true,
                "userScopes": {
                  "any": [],
                  "all": [
                    "marketing/affiliate.write"
                  ]
                }
              },
              {
                "name": "Campaign Create",
                "meta": "campaign-create-tab",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "affiliate_manager_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "campaign-create-page-v2",
                  "params": [
                    "location_id"
                  ]
                },
                "hide": true,
                "userScopes": {
                  "any": [],
                  "all": [
                    "marketing/affiliate.write"
                  ]
                }
              },
              {
                "name": "Campaign Edit",
                "meta": "campaign-edit-tab",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "affiliate_manager_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "campaign-edit-page-v2",
                  "params": [
                    "location_id"
                  ]
                },
                "hide": true,
                "userScopes": {
                  "any": [],
                  "all": [
                    "marketing/affiliate.write"
                  ]
                }
              }
            ],
            "route": {
              "name": "affiliate-manager-campaign-page-v2",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "marketing/affiliate.write"
              ]
            }
          },
          {
            "name": "common.sidebar.affiliates",
            "meta": "affiliates-tab",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "affiliate_manager_enabled"
              ],
              "any": []
            },
            "items": [],
            "tooltip": null,
            "type": "header",
            "children": [
              {
                "name": "Affiliate",
                "meta": "affiliates-tab",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "affiliate_manager_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "affiliate-manager-affiliates-v2",
                  "params": [
                    "location_id"
                  ]
                },
                "children": [],
                "hide": true,
                "userScopes": {
                  "any": [],
                  "all": [
                    "marketing/affiliate.write"
                  ]
                }
              },
              {
                "name": "Affiliate Details",
                "meta": "affiliate-details-tab",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "affiliate_manager_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "affiliate-manager-affiliates-details-v2",
                  "params": [
                    "location_id"
                  ]
                },
                "hide": true,
                "userScopes": {
                  "any": [],
                  "all": [
                    "marketing/affiliate.write"
                  ]
                }
              }
            ],
            "route": {
              "name": "affiliate-manager-affiliates-v2",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "marketing/affiliate.write"
              ]
            }
          },
          {
            "name": "common.sidebar.payouts",
            "meta": "payouts-tab",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "affiliate_manager_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "affiliate-manager-payouts-v2",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "marketing/affiliate.write"
              ]
            }
          },
          {
            "name": "common.sidebar.media",
            "meta": "media-tab",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "affiliate_manager_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [
              {
                "name": "Media",
                "meta": "media-tab",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "affiliate_manager_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "affiliate-manager-media-v2",
                  "params": [
                    "location_id"
                  ]
                },
                "children": [],
                "hide": true,
                "userScopes": {
                  "any": [],
                  "all": [
                    "marketing/affiliate.write"
                  ]
                }
              },
              {
                "name": "Media Folder",
                "meta": "media-folder-tab",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "affiliate_manager_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "affiliate-manager-media-folder-v2",
                  "params": [
                    "location_id"
                  ]
                },
                "hide": true,
                "userScopes": {
                  "any": [],
                  "all": [
                    "marketing/affiliate.write"
                  ]
                }
              }
            ],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "affiliate-manager-media-v2",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "marketing/affiliate.write"
              ]
            }
          },
          {
            "name": "Settings",
            "meta": "settings-tab",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "affiliate_manager_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "affiliate-manager-settings-v2",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "marketing/affiliate.write"
              ]
            }
          }
        ],
        "route": {
          "name": "affiliate-manager-campaign-page-v2",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "marketing/affiliate.write"
          ]
        }
      },
      {
        "name": "common.sidebar.brandBoards",
        "meta": "brand-boards",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "marketing_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "badge": {
          "enable": false,
          "title": "common.sidebar.new"
        },
        "route": {
          "name": "brand-boards",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "marketing.write"
          ]
        }
      },
      {
        "name": "common.sidebar.adManager",
        "meta": "ad-manager-home",
        "hide": false,
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [],
          "any": []
        },
        "badge": {
          "enable": false,
          "title": "common.sidebar.new"
        },
        "items": [
          {
            "name": "Settings",
            "meta": "ad-manager-settings",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "ad-manager-settings",
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": "fb/oauth-finish",
            "meta": "fb-oauth-finish",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "fb-oauth-finish",
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": "Campaign Statisics",
            "meta": "campaign-statistics",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "campaign-statistics",
              "params": [
                "location_id",
                "campaignId"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": []
            }
          }
        ],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "ad-manager-home",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.prospecting",
        "meta": "prospecting",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "badge": {
          "enable": true,
          "title": "common.sidebar.new"
        },
        "route": {
          "name": "prospecting",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      }
    ],
    "route": {
      "name": "marketing-v2",
      "params": [
        "location_id"
      ]
    },
    "userScopes": {
      "any": [
        "socialplanner/post.write",
        "marketing.write"
      ],
      "all": []
    }
  },
  {
    "name": "common.sidebar.automation",
    "enabled": true,
    "meta": "automation",
    "type": "header",
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/icon_automation.svg",
    "tooltip": "common.sidebar.automation",
    "permissions": {
      "all": [],
      "any": [
        "workflows_enabled",
        "workflows_read_only",
        "campaigns_enabled",
        "campaigns_read_only",
        "triggers_enabled"
      ]
    },
    "children": [
      {
        "name": "common.sidebar.workflows",
        "meta": "workflow",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [],
          "any": [
            "workflows_enabled",
            "workflows_read_only"
          ]
        },
        "items": [
          {
            "name": "New Workflows",
            "meta": "new-workflow",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "workflows_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": automationRouteNames.newWorkflows,
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "workflows.readonly",
                "workflows.write"
              ]
            }
          }
        ],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": automationRouteNames.workflows,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [
            "workflows.readonly",
            "workflows.write",
            "workflows.readonly"
          ],
          "all": []
        }
      },
      {
        "name": "common.sidebar.campaigns",
        "meta": "campaigns",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [],
          "any": [
            "campaigns_enabled",
            "campaigns_read_only"
          ]
        },
        "items": [
          {
            "name": "Edit",
            "meta": "campaigns-edit",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "campaigns_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": automationRouteNames.campaignEdit,
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "campaigns.readonly",
                "campaigns.write"
              ]
            }
          },
          {
            "name": "List",
            "meta": "campaigns-list",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "campaigns_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": automationRouteNames.campaignAccountsList,
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "campaigns.readonly",
                "campaigns.write"
              ]
            }
          },
          {
            "name": "Details",
            "meta": "campaigns-details",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "campaigns_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": automationRouteNames.campaignDetail,
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "campaigns.readonly",
                "campaigns.write"
              ]
            }
          },
          {
            "name": "Activity",
            "meta": "campaigns-activity",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "campaigns_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": automationRouteNames.campaignActivity,
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "campaigns.readonly",
                "campaigns.write"
              ]
            }
          }
        ],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": automationRouteNames.campaigns,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [
            "campaigns.readonly",
            "campaigns.write",
            "campaigns.readonly"
          ],
          "all": []
        }
      },
      {
        "name": "common.sidebar.triggers",
        "meta": "triggers",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "triggers_enabled"
          ],
          "any": []
        },
        "items": [
          {
            "name": "common.sidebar.details",
            "meta": "triggers-details",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "triggers_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": automationRouteNames.triggerDetail,
              "params": [
                "location_id",
                "trigger_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "triggers.write"
              ]
            }
          }
        ],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": automationRouteNames.triggers,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "triggers.write"
          ]
        }
      },
      {
        "name": "",
        "meta": "workflow-divider",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "settings_enabled",
            "workflows_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "divider",
        "route": null,
        "userScopes": {
          "any": [
            "workflows.readonly",
            "workflows.write"
          ],
          "all": [
            "settings.write",
          ]
        }
      },
      {
        "name": "common.sidebar.workflowSettings",
        "meta": "workflow-settings-top",
        "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/icon_settings.svg",
        "enabled": true,
        "permissions": {
          "all": [
            "settings_enabled",
            "workflows_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": null,
        "reference_route": {
          "name": locationSettingsRouteNames.automation,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [
            "workflows.readonly",
            "workflows.write"
          ],
          "all": [
            "settings.write"
          ]
        }
      }
    ],
    "items": [],
    "route": {
      "name": automationRouteNames.default,
      "params": [
        "location_id"
      ]
    },
    "userScopes": {
      "any": [
        "workflows.readonly",
        "workflows.write",
        "workflows.readonly",
        "campaigns.readonly",
        "campaigns.write",
        "campaigns.readonly",
        "triggers.write"
      ],
      "all": []
    }
  },
  {
    "name": "common.sidebar.sites",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "sites",
    "tooltip": "common.sidebar.sites",
    "permissions": {
      "all": [],
      "any": [
        "funnels_enabled",
        "websites_enabled",
        "membership_enabled",
        "forms_enabled",
        "surveys_enabled",
        "marketing_enabled",
        "web_chat_enabled",
        "qr_codes_enabled",
        "wordpress_enabled"
      ]
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/icon_sites.svg",
    "children": [
      {
        "name": "common.sidebar.funnels",
        "meta": "funnels",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "funnels_enabled"
          ],
          "any": []
        },
        "items": [
          {
            "name": "Funnel Details",
            "meta": "funnel-details",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "funnels_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [
              {
                "name": "Funnel Steps",
                "meta": "funnel-steps",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "funnels_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [
                  {
                    "name": "Overview",
                    "meta": "funnel-steps-overview",
                    "icon": null,
                    "enabled": true,
                    "permissions": {
                      "all": [
                        "funnels_enabled"
                      ],
                      "any": []
                    },
                    "items": [],
                    "children": [],
                    "tooltip": null,
                    "type": "header",
                    "route": {
                      "name": "funnel-step-overview-v2",
                      "params": [
                        "location_id",
                        "funnel_id",
                        "step_id"
                      ]
                    },
                    "userScopes": {
                      "any": [],
                      "all": [
                        "funnels.write"
                      ]
                    }
                  },
                  {
                    "name": "Automation",
                    "meta": "funnel-step-automation",
                    "icon": null,
                    "enabled": true,
                    "permissions": {
                      "all": [
                        "funnels_enabled"
                      ],
                      "any": []
                    },
                    "items": [],
                    "children": [],
                    "tooltip": null,
                    "type": "header",
                    "route": {
                      "name": "funnel-step-automation-v2",
                      "params": [
                        "location_id",
                        "funnel_id",
                        "step_id"
                      ]
                    },
                    "userScopes": {
                      "any": [],
                      "all": [
                        "funnels.write"
                      ]
                    }
                  },
                  {
                    "name": "Publish",
                    "meta": "funnel-step-publish",
                    "icon": null,
                    "enabled": true,
                    "permissions": {
                      "all": [
                        "funnels_enabled"
                      ],
                      "any": []
                    },
                    "items": [],
                    "children": [],
                    "tooltip": null,
                    "type": "header",
                    "route": {
                      "name": "funnel-step-publish-v2",
                      "params": [
                        "location_id",
                        "funnel_id",
                        "step_id"
                      ]
                    },
                    "userScopes": {
                      "any": [],
                      "all": [
                        "funnels.write"
                      ]
                    }
                  },
                  {
                    "name": "Product",
                    "meta": "funnel-step-product",
                    "icon": null,
                    "enabled": true,
                    "permissions": {
                      "all": [
                        "funnels_enabled"
                      ],
                      "any": []
                    },
                    "items": [],
                    "children": [],
                    "tooltip": null,
                    "type": "header",
                    "route": {
                      "name": "funnel-step-product-v2",
                      "params": [
                        "location_id",
                        "funnel_id",
                        "step_id"
                      ]
                    },
                    "userScopes": {
                      "any": [],
                      "all": [
                        "funnels.write"
                      ]
                    }
                  },
                  {
                    "name": "Products",
                    "meta": "funnel-step-products",
                    "icon": null,
                    "enabled": true,
                    "permissions": {
                      "all": [
                        "funnels_enabled"
                      ],
                      "any": []
                    },
                    "items": [],
                    "children": [],
                    "tooltip": null,
                    "type": "header",
                    "route": {
                      "name": "funnel-step-products-v2",
                      "params": [
                        "location_id",
                        "funnel_id",
                        "step_id"
                      ]
                    },
                    "userScopes": {
                      "any": [],
                      "all": [
                        "funnels.write"
                      ]
                    }
                  },
                  {
                    "name": "Create",
                    "meta": "funnel-steps-product-create",
                    "icon": null,
                    "enabled": true,
                    "permissions": {
                      "all": [
                        "funnels_enabled"
                      ],
                      "any": []
                    },
                    "items": [],
                    "children": [],
                    "tooltip": null,
                    "type": "header",
                    "route": {
                      "name": "funnel-step-product-v2",
                      "params": [
                        "location_id",
                        "funnel_id",
                        "step_id"
                      ]
                    },
                    "userScopes": {
                      "any": [],
                      "all": [
                        "funnels.write"
                      ]
                    }
                  },
                  {
                    "name": "Edit",
                    "meta": "funnel-steps-product-edit",
                    "icon": null,
                    "enabled": true,
                    "permissions": {
                      "all": [
                        "funnels_enabled"
                      ],
                      "any": []
                    },
                    "items": [],
                    "children": [],
                    "tooltip": null,
                    "type": "header",
                    "route": {
                      "name": "funnel-step-product-v2-edit",
                      "params": [
                        "location_id",
                        "funnel_id",
                        "step_id",
                        "funnel_product_id"
                      ]
                    },
                    "userScopes": {
                      "any": [],
                      "all": [
                        "funnels.write"
                      ]
                    }
                  }
                ],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "funnel-steps-v2",
                  "params": [
                    "location_id",
                    "funnel_id",
                    "step_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "funnels.write"
                  ]
                }
              },
              {
                "name": "Stats",
                "meta": "funnel-stats",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "funnels_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "funnel-stats-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "funnels.write"
                  ]
                }
              },
              {
                "name": "Sales",
                "meta": "funnel-sales",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "funnels_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "funnel-sales-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "funnels.write"
                  ]
                }
              },
              {
                "name": "Settings",
                "meta": "funnel-settings",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "funnels_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "funnel-settings-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "funnels.write"
                  ]
                }
              },
              {
                "name": "Security",
                "meta": "funnel-security",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "funnels_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "funnel-security-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "funnels.write"
                  ]
                }
              },
              {
                "name": "Events",
                "meta": "funnel-events",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "funnels_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "funnel-events-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "funnels.write"
                  ]
                }
              }
            ],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "funnels-detail-v2",
              "params": [
                "location_id",
                "funnel_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "funnels.write"
              ]
            }
          },
          {
            "name": "Funnels Templates",
            "meta": "funnels-templates",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "funnels_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "funnel-templates-category",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "funnels.write"
              ]
            }
          },
          {
            "name": "Funnels Templates Details",
            "meta": "funnels-templates-details",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "funnels_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "funnel-templates-category-detail",
              "params": [
                "location_id",
                "id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "funnels.write"
              ]
            }
          },
          {
            "name": "Funnels Templates Details Templates",
            "meta": "funnels-templates-details-temlates",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "funnels_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "funnel-templates-detail",
              "params": [
                "location_id",
                "id",
                "template_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "funnels.write"
              ]
            }
          }
        ],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "funnels-page-v2",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "funnels.write"
          ]
        }
      },
      {
        "name": "common.sidebar.websites",
        "meta": "websites",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "websites_enabled"
          ],
          "any": []
        },
        "items": [
          {
            "name": "Website Details",
            "meta": "website-details",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [],
              "any": []
            },
            "items": [
              {
                "name": "Pages",
                "meta": "website-pages",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "website-pages-v2",
                  "params": [
                    "location_id",
                    "funnel_id",
                    "step_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Stats",
                "meta": "website-stats",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "website-stats-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Sales",
                "meta": "website-sales",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "website-sales-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Settings",
                "meta": "website-settings",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "website-settings-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Security",
                "meta": "website-security",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "website-security-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Events",
                "meta": "website-events",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "website-events-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Products",
                "meta": "website-products",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "website-products-v2",
                  "params": [
                    "location_id",
                    "funnel_id",
                    "step_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Website Products",
                "meta": "website-step-products",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "website-step-products-v2",
                  "params": [
                    "location_id",
                    "funnel_id",
                    "step_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Website Products Create",
                "meta": "website-step-products-create",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "website-step-product-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Website Products Edit",
                "meta": "website-step-products-edit",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "website-step-product-v2-edit",
                  "params": [
                    "location_id",
                    "funnel_id",
                    "funnel_product_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              }
            ],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "websites-detail-v2",
              "params": [
                "location_id",
                "funnel_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": "Websites Templates",
            "meta": "websites-templates",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "websites_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "website-templates-category",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "websites.write"
              ]
            }
          },
          {
            "name": "Websites Templates Details",
            "meta": "websites-templates-details",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "websites_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "website-templates-category-detail",
              "params": [
                "location_id",
                "id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "websites.write"
              ]
            }
          },
          {
            "name": "Websites Templates Details Templates",
            "meta": "websites-templates-details-temlates",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "websites_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "website-templates-detail",
              "params": [
                "location_id",
                "id",
                "template_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "websites.write"
              ]
            }
          }
        ],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "websites-funnels-v2",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "websites.write"
          ]
        }
      },
      {
        "name": "common.sidebar.stores",
        "meta": "stores",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "websites_enabled"
          ],
          "any": []
        },
        "items": [
          {
            "name": "Store Details",
            "meta": "store-details",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [],
              "any": []
            },
            "items": [
              {
                "name": "Pages",
                "meta": "store-pages",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "store-pages-v2",
                  "params": [
                    "location_id",
                    "funnel_id",
                    "step_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Stats",
                "meta": "store-stats",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "store-stats-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Products",
                "meta": "store-product-select",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "store-product-select-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Sales",
                "meta": "store-sales",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "store-sales-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Settings",
                "meta": "store-settings",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "store-settings-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Security",
                "meta": "store-security",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "store-security-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Events",
                "meta": "store-events",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "store-events-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Products",
                "meta": "store-products",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "store-products-v2",
                  "params": [
                    "location_id",
                    "funnel_id",
                    "step_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Store Products",
                "meta": "store-step-products",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "store-step-products-v2",
                  "params": [
                    "location_id",
                    "funnel_id",
                    "step_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Store Products Create",
                "meta": "store-step-products-create",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "store-step-product-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Store Products Edit",
                "meta": "store-step-products-edit",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "store-step-product-v2-edit",
                  "params": [
                    "location_id",
                    "funnel_id",
                    "funnel_product_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              }
            ],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "store-detail-v2",
              "params": [
                "location_id",
                "funnel_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": "Stores Templates",
            "meta": "store-templates",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "websites_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "store-templates-category",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "websites.write"
              ]
            }
          },
          {
            "name": "Stores Templates Details",
            "meta": "store-templates-details",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "websites_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "store-templates-category-detail",
              "params": [
                "location_id",
                "id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "websites.write"
              ]
            }
          },
          {
            "name": "Stores Templates Details Templates",
            "meta": "store-templates-details-temlates",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "websites_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "store-templates-detail",
              "params": [
                "location_id",
                "id",
                "template_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "websites.write"
              ]
            }
          }
        ],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "stores-funnels-v2",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "websites.write"
          ]
        }
      },
      {
        "name": "common.sidebar.webinars",
        "meta": "webinars",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "websites_enabled"
          ],
          "any": []
        },
        "items": [
          {
            "name": "Webinar Details",
            "meta": "webinar-details",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [],
              "any": []
            },
            "items": [
              {
                "name": "Pages",
                "meta": "webinar-pages",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "webinar-pages-v2",
                  "params": [
                    "location_id",
                    "funnel_id",
                    "step_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Stats",
                "meta": "webinar-stats",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "webinar-stats-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Sales",
                "meta": "webinar-sales",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "webinar-sales-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Settings",
                "meta": "webinar-settings",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "webinar-settings-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Security",
                "meta": "webinar-security",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "webinar-security-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Events",
                "meta": "webinar-events",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "webinar-events-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Products",
                "meta": "webinar-products",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "webinar-products-v2",
                  "params": [
                    "location_id",
                    "funnel_id",
                    "step_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Webinar Products",
                "meta": "webinar-step-products",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "webinar-step-products-v2",
                  "params": [
                    "location_id",
                    "funnel_id",
                    "step_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Webinar Products Create",
                "meta": "webinar-step-products-create",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "webinar-step-product-v2",
                  "params": [
                    "location_id",
                    "funnel_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              },
              {
                "name": "Webinar Products Edit",
                "meta": "webinar-step-products-edit",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "websites_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "webinar-step-product-v2-edit",
                  "params": [
                    "location_id",
                    "funnel_id",
                    "funnel_product_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "websites.write"
                  ]
                }
              }
            ],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "webinars-detail-v2",
              "params": [
                "location_id",
                "funnel_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": "Webinars Templates",
            "meta": "webinars-templates",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "websites_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "webinar-templates-category",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "websites.write"
              ]
            }
          },
          {
            "name": "Webinars Templates Details",
            "meta": "webinars-templates-details",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "websites_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "webinar-templates-category-detail",
              "params": [
                "location_id",
                "id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "websites.write"
              ]
            }
          },
          {
            "name": "Webinars Templates Details Templates",
            "meta": "webinars-templates-details-temlates",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "websites_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "webinar-templates-detail",
              "params": [
                "location_id",
                "id",
                "template_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "websites.write"
              ]
            }
          }
        ],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "webinars-funnels-v2",
          "params": [
            "location_id"
          ]
        },
        "badge": {
          "enable": false,
          "title": "common.sidebar.new"
        },
        "userScopes": {
          "any": [],
          "all": [
            "websites.write"
          ]
        }
      },
      {
        "name": "common.sidebar.seo",
        "meta": "seo",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [],
          "any": [
            "websites_enabled",
            "funnels_enabled"
          ]
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": seoRouteNames.default,
          "params": [
            "location_id"
          ]
        },
        "badge": {
          "enable": true,
          "title": "common.sidebar.beta"
        },
        "userScopes": {
          "any": [
            "websites.write",
            "funnels.write"
          ],
          "all": []
        }
      },
      {
        "name": i18n.t("common.sidebar.analytics"),
        "meta": "analytics",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [],
          "any": [
            "websites_enabled",
            "funnels_enabled"
          ]
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": analyticsRouteNames.default,
          "params": [
            "location_id"
          ]
        },
        "badge": {
          "enable": false,
          "title": "common.sidebar.new"
        },
        "userScopes": {
          "any": [
            "websites.write",
            "funnels.write"
          ],
          "all": []
        }
      },
      {
        "name": "common.sidebar.blogs",
        "enabled": true,
        "meta": "blogs",
        "icon": "",
        "items": [
          {
            "name": "Settings",
            "meta": "blogs-settings",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": blogsRouteNames.settings,
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": "New Blog",
            "meta": "blogs-site-new",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": blogsRouteNames.new,
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": "Blog posts",
            "meta": "blogs-site-list",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": blogsRouteNames.list,
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": "Blog setting",
            "meta": "blog-setting",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": blogsRouteNames.blogSettings,
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": []
            }
          }
        ],
        "children": [],
        "permissions": {
          "all": [
            "blogging_enabled"
          ],
          "any": []
        },
        "type": "header",
        "route": {
          "name": blogsRouteNames.default,
          "params": [
            "location_id"
          ]
        },
        "badge": {
          "enable": false,
          "title": "common.sidebar.new"
        },
        "userScopes": {
          "any": [],
          "all": [
            "blogs.write"
          ]
        }
      },
      {
        "name": "common.sidebar.wordPress",
        "meta": "wordpress-v2",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [],
          "any": [
            "wordpress_enabled"
          ]
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "wordpress-v2",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [
            "wordpress.write"
          ],
          "all": []
        }
      },
      {
        "name": "common.sidebar.clientPortal",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "clientportal",
        "tooltip": "common.sidebar.clientPortal",
        "permissions": {
          "all": [],
          "any": [
            "membership_enabled",
            "affiliate_manager_enabled",
            "communities_enabled"
          ]
        },
        "children": [
          {
            "name": "common.sidebar.dashboard",
            "meta": "clientportal-dashboard",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [],
              "any": [
                "membership_enabled",
                "affiliate_manager_enabled",
                "communities_enabled"
              ]
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "clientportal-dashboard",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [
                "membership.write",
                "marketing/affiliate.write",
                "communities.write"
              ],
              "all": []
            }
          },
          {
            "name": "common.sidebar.settings",
            "meta": "clientportal-settings",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [],
              "any": [
                "membership_enabled",
                "affiliate_manager_enabled",
                "communities_enabled"
              ]
            },
            "items": [],
            "children": [
              {
                "name": "Dashboard Settings",
                "meta": "clientportal-settings",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [],
                  "any": [
                    "membership_enabled",
                    "affiliate_manager_enabled",
                    "communities_enabled"
                  ]
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "clientportal-settings",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [
                    "membership.write",
                    "marketing/affiliate.write",
                    "communities.write"
                  ],
                  "all": []
                }
              },
              {
                "name": "Domain Setup",
                "meta": "clientportal-domain-setup",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [],
                  "any": [
                    "membership_enabled",
                    "affiliate_manager_enabled",
                    "communities_enabled"
                  ]
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "clientportal-domain-setup",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [
                    "membership.write",
                    "marketing/affiliate.write",
                    "communities.write"
                  ],
                  "all": []
                }
              },
              {
                "name": "common.sidebar.branding",
                "meta": "branding",
                "icon": null,
                "enabled": false,
                "permissions": {
                  "all": [],
                  "any": [
                    "membership_enabled",
                    "affiliate_manager_enabled",
                    "communities_enabled"
                  ]
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "branding",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [
                    "membership.write",
                    "marketing/affiliate.write",
                    "communities.write"
                  ],
                  "all": []
                }
              },
              {
                "name": "App Permissions",
                "meta": "app-permission",
                "icon": null,
                "enabled": false,
                "permissions": {
                  "all": [],
                  "any": [
                    "membership_enabled",
                    "affiliate_manager_enabled",
                    "communities_enabled"
                  ]
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "app-permission",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [
                    "membership.write",
                    "marketing/affiliate.write",
                    "communities.write"
                  ],
                  "all": []
                }
              },
              {
                "name": "Email Settings",
                "meta": "email-settings",
                "icon": null,
                "enabled": false,
                "permissions": {
                  "all": [],
                  "any": [
                    "membership_enabled",
                    "affiliate_manager_enabled",
                    "communities_enabled"
                  ]
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "email-settings",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [
                    "membership.write",
                    "marketing/affiliate.write",
                    "communities.write"
                  ],
                  "all": []
                }
              },
              {
                "name": "Language Settings",
                "meta": "language-settings",
                "icon": null,
                "enabled": false,
                "permissions": {
                  "all": [],
                  "any": [
                    "membership_enabled",
                    "affiliate_manager_enabled",
                    "communities_enabled"
                  ]
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "language-settings",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [
                    "membership.write",
                    "marketing/affiliate.write",
                    "communities.write"
                  ],
                  "all": []
                }
              },
              {
                "name": "Chat Widget",
                "meta": "chat-widget-settings",
                "icon": null,
                "enabled": false,
                "permissions": {
                  "all": [],
                  "any": ["membership_enabled", "affiliate_manager_enabled", "communities_enabled"]
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "chat-widget-settings",
                  "params": ["location_id"]
                }
              }
            ],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "clientportal-settings",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [
                "membership.write",
                "marketing/affiliate.write",
                "communities.write"
              ],
              "all": []
            }
          },
          {
            "name": "Branded Mobile App",
            "meta": "branded-app",
            "icon": null,
            "enabled": false,
            "permissions": {
              "all": [],
              "any": [
                "membership_enabled",
                "affiliate_manager_enabled",
                "communities_enabled"
              ]
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "branded-app",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [
                "membership.write",
                "marketing/affiliate.write",
                "communities.write"
              ],
              "all": []
            }
          }
        ],
        "route": {
          "name": "clientportal-settings",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [
            "membership.write",
            "marketing/affiliate.write",
            "communities.write"
          ],
          "all": []
        }
      },
      {
        "name": "common.sidebar.forms",
        "meta": "form-builder",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "forms_enabled"
          ],
          "any": []
        },
        "items": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "form-builder-v2",
          "params": [
            "location_id"
          ]
        },
        "children": [
          {
            "name": "common.sidebar.builder",
            "meta": "form-builder-main",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "forms_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "form-builder-main-v2",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "forms.write"
              ]
            }
          },
          {
            "name": "common.sidebar.analyze",
            "meta": "form-builder-analyze",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "forms_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "form-builder-analyze-v2",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "forms.write"
              ]
            }
          },
          {
            "name": "common.sidebar.submissions",
            "meta": "form-builder-submissions",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "forms_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "form-builder-submissions-v2",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "forms.write"
              ]
            }
          },
          {
            "name": "common.sidebar.manage",
            "meta": "form-builder-create",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "forms_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "form-builder-manage",
              "params": [
                "location_id",
                "builder_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "forms.write"
              ]
            }
          },
          {
            "name": "Jotbox Form",
            "meta": "form-builder-jotbox",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "forms_enabled",
                "marketing_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "jotbox_form-v2",
              "params": [
                "location_id",
                "builder_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "forms.write",
                "marketing.write"
              ]
            }
          }
        ],
        "userScopes": {
          "any": [],
          "all": [
            "forms.write"
          ]
        }
      },
      {
        "name": "common.sidebar.surveys",
        "meta": "survey-builder",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "surveys_enabled"
          ],
          "any": []
        },
        "items": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "survey-builder-v2",
          "params": [
            "location_id"
          ]
        },
        "children": [
          {
            "name": "common.sidebar.builder",
            "meta": "survey-builder-main",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "surveys_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "survey-builder-main-v2",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "surveys.write"
              ]
            }
          },
          {
            "name": "common.sidebar.analyze",
            "meta": "survey-builder-analyze",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "surveys_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "survey-builder-analyze-v2",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "surveys.write"
              ]
            }
          },
          {
            "name": "common.sidebar.submissions",
            "meta": "survey-builder-submissions",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "surveys_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "survey-builder-submissions-v2",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "surveys.write"
              ]
            }
          },
          {
            "name": "common.sidebar.manage",
            "meta": "survey-builder-create",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "surveys_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "survey-manage",
              "params": [
                "location_id",
                "survey_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "surveys.write"
              ]
            }
          },
          {
            "name": "Jotbox Survey",
            "meta": "survey-builder-jotbox",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "surveys_enabled",
                "marketing_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "jotbox_survey-v2",
              "params": [
                "location_id",
                "survey_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "surveys.write",
                "marketing.write"
              ]
            }
          }
        ],
        "userScopes": {
          "any": [],
          "all": [
            "surveys.write"
          ]
        }
      },
      {
        "name": "common.sidebar.quizzes",
        "meta": "quiz-builder",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "quizzes_enabled"
          ],
          "any": []
        },
        "items": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "quiz-builder-v2",
          "params": [
            "location_id"
          ]
        },
        "badge": {
          "enable": false,
          "title": "common.sidebar.new"
        },
        "children": [
          {
            "name": "common.sidebar.builder",
            "meta": "quiz-builder-main",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "quizzes_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "quiz-builder-main",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "quizzes.write"
              ]
            }
          },
          {
            "name": "common.sidebar.submissions",
            "meta": "quiz-builder-submissions",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "quizzes_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "quiz-builder-submissions",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "quizzes.write"
              ]
            }
          }
        ],
        "userScopes": {
          "any": [],
          "all": [
            "quizzes.write"
          ]
        }
      },
      {
        "name": "common.sidebar.chatWidget",
        "meta": "chat-widget",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "settings_enabled",
            "web_chat_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "chat-widget",
          "params": [
            "location_id"
          ]
        },
        "badge": {
          "enable": false,
          "title": "common.sidebar.new"
        },
        "userScopes": {
          "any": [],
          "all": [
            "settings.write"
          ]
        }
      },
      {
        "name": "common.sidebar.qrCode",
        "meta": "qr-codes",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "qr_codes_enabled",
            "marketing_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "qr-codes",
          "params": [
            "location_id"
          ]
        },
        "badge": {
          "enable": false,
          "title": "common.sidebar.new"
        },
        "userScopes": {
          "any": [],
          "all": [
            "qrcodes.write",
            "marketing.write"
          ]
        }
      },
      {
        "name": "",
        "meta": "sites-divider",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "settings_enabled",
            "websites_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "divider",
        "route": null,
        "userScopes": {
          "any": [],
          "all": [
            "settings.write",
            "websites.write"
          ]
        }
      },
      {
        "name": "",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "sites-domain-settings",
        "tooltip": "Domain",
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": [
            "funnels_enabled",
            "websites_enabled"
          ]
        },
        "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/icon_settings.svg",
        "children": [],
        "route": null,
        "reference_route": {
          "name": locationSettingsRouteNames.domain,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [
            "funnels.write",
            "websites.write"
          ],
          "all": [
            "settings.write"
          ]
        }
      }
    ],
    "route": {
      "name": "funnels-v2",
      "params": [
        "location_id"
      ]
    },
    "userScopes": {
      "any": [
        "funnels.write",
        "websites.write",
        "membership.write",
        "forms.write",
        "surveys.write",
        "marketing.write",
        "qrcodes.write",
        "wordpress.write"
      ],
      "all": []
    }
  },
  {
    "name": "common.sidebar.memberships",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "memberships",
    "tooltip": "common.sidebar.memberships",
    "permissions": {
      "all": [],
      "any": [
        "membership_enabled",
        "communities_enabled",
        "certificates_enabled"
      ]
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/memberships.svg",
    "children": [
      {
        "name": "common.sidebar.clientPortal",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "clientportalCommunities",
        "tooltip": "common.sidebar.clientPortal",
        "permissions": {
          "all": [],
          "any": [
            "membership_enabled",
            "affiliate_manager_enabled",
            "communities_enabled"
          ]
        },
        "children": [
          {
            "name": "common.sidebar.dashboard",
            "meta": "clientportal-dashboard-memberships",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [],
              "any": [
                "membership_enabled",
                "affiliate_manager_enabled",
                "communities_enabled"
              ]
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "clientportal-dashboard-memberships",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [
                "membership.write",
                "marketing/affiliate.write",
                "communities.write"
              ],
              "all": []
            }
          },
          {
            "name": "common.sidebar.settings",
            "meta": "clientportal-settings-memberships",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [],
              "any": [
                "membership_enabled",
                "affiliate_manager_enabled",
                "communities_enabled"
              ]
            },
            "items": [],
            "children": [
              {
                "name": "Dashboard Settings",
                "meta": "clientportal-settings-memberships",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [],
                  "any": [
                    "membership_enabled",
                    "affiliate_manager_enabled",
                    "communities_enabled"
                  ]
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "clientportal-settings-memberships",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [
                    "membership.write",
                    "marketing/affiliate.write",
                    "communities.write"
                  ],
                  "all": []
                }
              },
              {
                "name": "Domain Setup",
                "meta": "clientportal-domain-setup-memberships",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [],
                  "any": [
                    "membership_enabled",
                    "affiliate_manager_enabled",
                    "communities_enabled"
                  ]
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "clientportal-domain-setup-memberships",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [
                    "membership.write",
                    "marketing/affiliate.write",
                    "communities.write"
                  ],
                  "all": []
                }
              },
              {
                "name": "common.sidebar.branding",
                "meta": "branding-memberships",
                "icon": null,
                "enabled": false,
                "permissions": {
                  "all": [],
                  "any": [
                    "membership_enabled",
                    "affiliate_manager_enabled",
                    "communities_enabled"
                  ]
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "branding-memberships",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [
                    "membership.write",
                    "marketing/affiliate.write",
                    "communities.write"
                  ],
                  "all": []
                }
              },
              {
                "name": "App Permissions",
                "meta": "app-permission-memberships",
                "icon": null,
                "enabled": false,
                "permissions": {
                  "all": [],
                  "any": [
                    "membership_enabled",
                    "affiliate_manager_enabled",
                    "communities_enabled"
                  ]
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "app-permission-memberships",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [
                    "membership.write",
                    "marketing/affiliate.write",
                    "communities.write"
                  ],
                  "all": []
                }
              },
              {
                "name": "Email Settings",
                "meta": "email-settings-memberships",
                "icon": null,
                "enabled": false,
                "permissions": {
                  "all": [],
                  "any": [
                    "membership_enabled",
                    "affiliate_manager_enabled",
                    "communities_enabled"
                  ]
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "email-settings-memberships",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [
                    "membership.write",
                    "marketing/affiliate.write",
                    "communities.write"
                  ],
                  "all": []
                }
              },
              {
                "name": "Language Settings",
                "meta": "language-settings-memberships",
                "icon": null,
                "enabled": false,
                "permissions": {
                  "all": [],
                  "any": [
                    "membership_enabled",
                    "affiliate_manager_enabled",
                    "communities_enabled"
                  ]
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "language-settings-memberships",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [
                    "membership.write",
                    "marketing/affiliate.write",
                    "communities.write"
                  ],
                  "all": []
                }
              },
              {
                "name": "Chat Widget",
                "meta": "chat-widget-settings-memberships",
                "icon": null,
                "enabled": false,
                "permissions": {
                  "all": [],
                  "any": ["membership_enabled", "affiliate_manager_enabled", "communities_enabled"]
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "chat-widget-settings-memberships",
                  "params": ["location_id"]
                }
              }
            ],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "clientportal-settings-memberships",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [
                "membership.write",
                "marketing/affiliate.write",
                "communities.write"
              ],
              "all": []
            }
          },
          {
            "name": "Branded Mobile App",
            "meta": "branded-app-memberships",
            "icon": null,
            "enabled": false,
            "permissions": {
              "all": [],
              "any": [
                "membership_enabled",
                "affiliate_manager_enabled",
                "communities_enabled"
              ]
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "branded-app-memberships",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [
                "membership.write",
                "marketing/affiliate.write",
                "communities.write"
              ],
              "all": []
            }
          }
        ],
        "route": {
          "name": "clientportal-settings-memberships",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [
            "membership.write",
            "marketing/affiliate.write",
            "communities.write"
          ],
          "all": []
        }
      },
      {
        "name": "common.sidebar.courses",
        "meta": "courses",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "membership_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [
          {
            "name": "common.sidebar.dashboard",
            "meta": "dashboard",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "membership-dashboard-v2",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "common.sidebar.products",
            "meta": "products",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [
              {
                "name": "Membership Products",
                "meta": "membership-products-v2",
                "icon": null,
                "enabled": true,
                "hide": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "membership-products-v2",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              },
              {
                "name": "Library Sorting",
                "meta": "memberships-library-sorting",
                "icon": null,
                "enabled": true,
                "hide": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "membership-library-order-v2",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              },
              {
                "name": "Product Detail",
                "meta": "memberships-product-detail",
                "icon": null,
                "enabled": true,
                "hide": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "membership-product-overview-v2",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              },
              {
                "name": "Product Edit",
                "meta": "memberships-product-edit",
                "icon": null,
                "enabled": true,
                "hide": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "membership-product-edit-v2",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              },
              {
                "name": "Product Offers",
                "meta": "memberships-product-offers",
                "icon": null,
                "enabled": true,
                "hide": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "membership-product-offers",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              },
              {
                "name": "Product Comments",
                "meta": "membership-product-comments",
                "icon": null,
                "enabled": true,
                "hide": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "membership-product-comments",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              }
            ],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "membership-products-v2",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "common.sidebar.productBlueprints",
            "meta": "membership-product-blueprints",
            "icon": null,
            "enabled": true,
            "hide": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "product_blueprints-v2",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "common.sidebar.offers",
            "meta": "offers",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [
              {
                "name": "Offers List",
                "meta": "memberships-offer-detail",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "offers-overview-v2",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              },
              {
                "name": "Offer Details",
                "meta": "membership-offer-detail-v2",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "membership-offer-detail-v2",
                  "params": [
                    "location_id",
                    "id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              },
              {
                "name": "Offer upsell",
                "meta": "upsell-home-v2",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "upsell-home-v2",
                  "params": [
                    "location_id",
                    "id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              }
            ],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "offers-overview-v2",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "common.sidebar.analytics",
            "meta": "analytics",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [
              {
                "name": "Membership-Analytics",
                "meta": "memberships-analytics-v2",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "membership-analytics-v2",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              },
              {
                "name": "Product-Progress",
                "meta": "memberships-product-progress",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [
                  {
                    "name": "Member-Progress",
                    "meta": "memberships-member-progress",
                    "icon": null,
                    "enabled": true,
                    "permissions": {
                      "all": [
                        "membership_enabled"
                      ],
                      "any": []
                    },
                    "items": [],
                    "children": [],
                    "tooltip": null,
                    "type": "header",
                    "route": {
                      "name": "member-progress-v2",
                      "params": [
                        "location_id"
                      ]
                    },
                    "userScopes": {
                      "any": [],
                      "all": [
                        "membership.write"
                      ]
                    }
                  }
                ],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "membership-product-progress-v2",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              },
              {
                "name": "Membership-Assessments",
                "meta": "membership-analytics-assessments",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [
                  {
                    "name": "Membership-Analytics-Submission",
                    "meta": "membership-analytics-submission-v2",
                    "icon": null,
                    "enabled": true,
                    "permissions": {
                      "all": [
                        "membership_enabled"
                      ],
                      "any": []
                    },
                    "items": [],
                    "children": [],
                    "tooltip": null,
                    "type": "header",
                    "route": {
                      "name": "membership-analytics-assessment-submission-v2",
                      "params": [
                        "location_id"
                      ]
                    },
                    "userScopes": {
                      "any": [],
                      "all": [
                        "membership.write"
                      ]
                    }
                  }
                ],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "membership-analytics-assessments-v2",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              }
            ],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "membership-analytics-v2",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "Net Revenue Analytics",
            "meta": "memberships-netrevenue-analytics",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "membership-netrevenue-analytics",
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "Product Certificates",
            "meta": "product-certificates",
            "icon": null,
            "enabled": true,
            "hide": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "product-certificates",
              "params": [
                "location_id",
                "product_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "Product Offers",
            "meta": "product-offers",
            "icon": null,
            "enabled": true,
            "hide": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "product-offers-v2",
              "params": [
                "location_id",
                "product_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "Product Groups",
            "meta": "product-groups",
            "icon": null,
            "enabled": true,
            "hide": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "product-groups",
              "params": [
                "location_id",
                "product_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "Course Importer",
            "meta": "course-importer",
            "icon": null,
            "enabled": true,
            "hide": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "course-importer",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "Courses Themes Overview",
            "meta": "courses-themes-overview",
            "icon": null,
            "enabled": true,
            "hide": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "courses-themes-overview",
              "params": [
                "location_id",
                "product_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "Courses Theme Customizer",
            "meta": "courses-theme-customizer",
            "icon": null,
            "enabled": true,
            "hide": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "courses-theme-customizer",
              "params": [
                "location_id",
                "product_id",
                "theme_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "Courses Template Customizer",
            "meta": "courses-template-customizer",
            "icon": null,
            "enabled": true,
            "hide": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "courses-template-customizer",
              "params": [
                "location_id",
                "product_id",
                "template_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "common.sidebar.membersAnalytics",
            "meta": "memberships-members-analytics",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "membership-members-analytics",
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "common.sidebar.membershipOffer",
            "meta": "memberships-offers",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "offers-v2",
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "Membership Offer List",
            "meta": "memberships-offers-list",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "offers-overview-v2",
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "common.sidebar.membersProgress",
            "meta": "memberships-members-progress",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "membership-members-progress",
              "params": [
                "location_id",
                "contact_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "Membership post edit",
            "meta": "membership-post-edit",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "membership-post-edit",
              "params": [
                "location_id",
                "post_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "Manage Comments",
            "meta": "membership-manage-comments-v2",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "membership-manage-comments-v2",
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "Category Edit",
            "meta": "categories-edit-v2",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "categories-edit-v2",
              "params": [
                "location_id",
                "id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "Offer Customization",
            "meta": "courses-offer-customization-v2",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "courses-offer-customization-v2",
              "params": [
                "location_id",
                "offer_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "common.sidebar.membershipOfferEdit",
            "meta": "courses-offer-edit-v2",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "courses-offer-edit-v2",
              "params": [
                "location_id",
                "id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "Assignment Edit",
            "meta": "post-assignment-v2",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "post-assignment-v2",
              "params": [
                "location_id",
                "id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "Quiz Edit",
            "meta": "post-quiz-v2",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "post-quiz-v2",
              "params": [
                "location_id",
                "id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "Assignment Submission",
            "meta": "assignment-evaluation",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "assignment-evaluation",
              "params": [
                "location_id",
                "id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "common.sidebar.categories",
            "meta": "memberships-categories",
            "icon": null,
            "enabled": true,
            "hide": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [
              {
                "name": "Category Edit",
                "meta": "memberships-category-edit",
                "icon": null,
                "enabled": true,
                "hide": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "membership-category-edit",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              }
            ],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "membership-categories-v2",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "common.sidebar.posts",
            "meta": "memberships-posts",
            "icon": null,
            "enabled": true,
            "hide": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [
              {
                "name": "Post Edit",
                "meta": "memberships-post-edit",
                "icon": null,
                "enabled": true,
                "hide": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "membership-post-edit",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              }
            ],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "membership-posts-v2",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "common.sidebar.themes",
            "meta": "memberships-themes",
            "icon": null,
            "enabled": true,
            "hide": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [
              {
                "name": "Edit Themese",
                "meta": "memberships-edit-themes",
                "icon": null,
                "enabled": true,
                "hide": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "membership-edit-themes-v2",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              }
            ],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "membership-themes-v2",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "common.sidebar.themesNew",
            "meta": "memberships-themes-new-v2",
            "icon": null,
            "enabled": true,
            "hide": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [
              {
                "name": "Edit Themes New",
                "meta": "memberships-edit-themes-new-v2",
                "icon": null,
                "enabled": true,
                "hide": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "membership-edit-themes-new-v2",
                  "params": [
                    "location_id",
                    "theme_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              },
              {
                "name": "Edit V2 Themes",
                "meta": "membership-edit-v2-themes",
                "icon": null,
                "enabled": true,
                "hide": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "membership-edit-v2-themes",
                  "params": [
                    "location_id",
                    "theme_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              },
              {
                "name": "Product All Theme",
                "meta": "membership-product-all-themes",
                "icon": null,
                "enabled": true,
                "hide": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "membership-product-all-themes",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              }
            ],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "membership-themes-new-v2",
              "params": [
                "location_id",
                "theme_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          },
          {
            "name": "common.sidebar.settings",
            "meta": "settings",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "membership_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [
              {
                "name": "Membership-Settings",
                "meta": "memberships-settings-v2",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "membership-settings-v2",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              },
              {
                "name": "Site-Details",
                "meta": "memberships-site-details",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "membership-site-details-v2",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              },
              {
                "name": "Custom-Domain",
                "meta": "memberships-custom-domain",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "membership-custom-domain-v2",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              },
              {
                "name": "Email-Settings",
                "meta": "memberships-email-settings",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "membership-email-settings-v2",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              },
              {
                "name": "App-Settings",
                "meta": "memberships-app-settings",
                "icon": null,
                "enabled": true,
                "permissions": {
                  "all": [
                    "membership_enabled"
                  ],
                  "any": []
                },
                "items": [],
                "children": [],
                "tooltip": null,
                "type": "header",
                "route": {
                  "name": "membership-app-settings-v2",
                  "params": [
                    "location_id"
                  ]
                },
                "userScopes": {
                  "any": [],
                  "all": [
                    "membership.write"
                  ]
                }
              }
            ],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "membership-settings-v2",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "membership.write"
              ]
            }
          }
        ],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "membership-dashboard-v2",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "membership.write"
          ]
        }
      },
      {
        "name": "common.sidebar.communities",
        "meta": "communities",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "communities_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [
          {
            "name": "common.sidebar.groups",
            "meta": "community-groups",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "communities_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "community-groups",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "communities.write"
              ]
            }
          },
          {
            "name": "common.sidebar.createGroup",
            "meta": "create-group",
            "icon": null,
            "enabled": true,
            "hide": true,
            "permissions": {
              "all": [
                "communities_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "create-group",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "communities.write"
              ]
            }
          },
          {
            "name": "common.sidebar.settings",
            "meta": "domain-settings",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "communities_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "communities-domain-setup",
              "query": {
                "source": "communities"
              },
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "communities.write"
              ]
            }
          },
          {
            "name": "Branded Mobile App",
            "meta": "communities-branded-app",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "communities_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "communities-branded-app",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "communities.write"
              ]
            }
          }
        ],
        "tooltip": null,
        "type": "header",
        "badge": {
          "enable": false,
          "title": "common.sidebar.new"
        },
        "route": {
          "name": "communities",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "communities.write"
          ]
        }
      },
      {
        "name": "common.sidebar.credentials",
        "meta": "certificates",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "certificates_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [
          {
            "name": "Create Certificates",
            "meta": "create-certificates",
            "icon": null,
            "enabled": true,
            "hide": true,
            "permissions": {
              "all": [
                "certificates_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "create-certificates",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "certificates.write"
              ]
            }
          },
          {
            "name": "Edit Certificates",
            "meta": "edit-certificates",
            "icon": null,
            "enabled": true,
            "hide": true,
            "permissions": {
              "all": [
                "certificates_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "edit-certificates",
              "params": [
                "location_id",
                "certificate_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "certificates.write"
              ]
            }
          },
          {
            "name": "Edit Badges",
            "meta": "edit-badges",
            "icon": null,
            "enabled": true,
            "hide": true,
            "permissions": {
              "all": [
                "certificates_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "edit-badges",
              "params": [
                "location_id",
                "badge_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "certificates.write"
              ]
            }
          }
        ],
        "tooltip": null,
        "type": "header",
        "badge": {
          "enable": true,
          "title": "New"
        },
        "route": {
          "name": "certificates",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "certificates.write"
          ]
        }
      },
      {
        "name": "Gokollab Marketplace",
        "meta": "gokollab",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "gokollab_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [
          {
            "name": "GoKollab Activation",
            "meta": "gokollab-activation",
            "icon": null,
            "enabled": true,
            "hide": true,
            "permissions": {
              "all": [
                "gokollab_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": membershipRouteNames.gokollab.activation,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "gokollab.write"
              ]
            }
          }
        ],
        "tooltip": null,
        "type": "header",
        "badge": {
          "enable": true,
          "title": "New"
        },
        "route": {
          "name": membershipRouteNames.gokollab.default,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "gokollab.write"
          ]
        }
      }
    ],
    "route": {
      "name": "memberships-v2",
      "params": [
        "location_id"
      ]
    },
    "userScopes": {
      "any": [
        "membership.write",
        "communities.write",
        "certificates.write"
      ],
      "all": []
    }
  },
  {
    "name": "common.sidebar.mediaStorage",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "app-media",
    "tooltip": "common.sidebar.mediaStorage",
    "permissions": {
      "all": [],
      "any": [
        "media_storage_enabled"
      ]
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/media-storage.svg",
    "children": [],
    "route": {
      "name": "media-settings-v2",
      "params": [
        "location_id"
      ]
    },
    "userScopes": {
      "any": [
        "medias.write"
      ],
      "all": []
    }
  },
  {
    "name": "common.sidebar.reputation",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "reputation",
    "tooltip": "common.sidebar.reputation",
    "permissions": {
      "all": [],
      "any": [
        "online_listings_enabled",
        "reviews_enabled"
      ]
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/icon_reputation.svg",
    "children": [
      {
        "name": "common.sidebar.overview",
        "meta": "reputation-overview",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "reviews_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "reputation-overview-v2",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "reputation/review.write"
          ]
        }
      },
      {
        "name": "common.sidebar.requests",
        "meta": "reputations-requests",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "reviews_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "reputation-review-requests-v2",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "reputation/review.write"
          ]
        }
      },
      {
        "name": "common.sidebar.reviews",
        "meta": "reputations-reviews",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "reviews_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "reputation-reviews-v2",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "reputation/review.write"
          ]
        }
      },
      {
        "name": "common.sidebar.widgets",
        "meta": "reputation-widgets",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "reviews_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "reputation-widget-v2",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "reputation/review.write"
          ]
        }
      },
      {
        "name": "common.sidebar.listings",
        "meta": "online-listings",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "online_listings_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "reputation-listing-v2",
          "params": [
            "location_id"
          ]
        },
        "badge": {
          "enable": false,
          "title": "common.sidebar.new"
        },
        "userScopes": {
          "any": [],
          "all": [
            "reputation/listing.write"
          ]
        }
      },
      {
        "name": "common.sidebar.settings",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "reputation-settings",
        "tooltip": null,
        "permissions": {
          "all": [
            "settings_enabled",
            "reviews_enabled"
          ],
          "any": []
        },
        "children": [],
        "route": {
          "name": "reputation-settings-v2",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "settings.write",
            "reputation/review.write"
          ]
        }
      },
      {
        "name": "common.sidebar.gbpOptimization",
        "meta": "gbp-optimization",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "online_listings_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": reputationRouteNames.gbp,
          "params": [
            "location_id"
          ]
        },
        "badge": {
          "enable": true,
          "title": "common.sidebar.new"
        },
        "userScopes": {
          "any": [],
          "all": [
            "reputation/listing.write"
          ]
        }
      }
    ],
    "route": {
      "name": "reputation-v2",
      "params": [
        "location_id"
      ]
    },
    "userScopes": {
      "any": [
        "reputation/listing.write",
        "reputation/review.write"
      ],
      "all": []
    }
  },
  {
    "name": "common.sidebar.reporting",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "reporting",
    "tooltip": "common.sidebar.reporting",
    "permissions": {
      "all": [],
      "any": [
        "adwords_reporting_enabled",
        "facebook_ads_reporting_enabled",
        "attributions_reporting_enabled",
        "phone_call_enabled",
        "agent_reporting_enabled",
        "appointments_enabled",
        "reporting_enabled"
      ]
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/icon_reporting.svg",
    "children": [
      {
        "name": "Custom Reports",
        "meta": "custom-reports",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "reporting_enabled"
          ],
          "any": []
        },
        "items": [],
        "type": "header",
        "children": [],
        "tooltip": null,
        "route": {
          "name": "reporting-custom",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "reporting/reports.write"
          ]
        }
      },
      {
        "name": i18n.t("common.sidebar.googleAds"),
        "meta": "google-ads",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "adwords_reporting_enabled"
          ],
          "any": []
        },
        "items": [],
        "type": "header",
        "children": [],
        "tooltip": null,
        "route": {
          "name": reportingRouteNames.google,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "reporting/adwords.readonly"
          ]
        }
      },
      {
        "name": "common.sidebar.facebookAds",
        "meta": "facebook-ads",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "facebook_ads_reporting_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "route": {
          "name": reportingRouteNames.facebook,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "reporting/facebookAds.readonly"
          ]
        }
      },
      {
        "name": "common.sidebar.attributionReport",
        "meta": "attribution-v2",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "attributions_reporting_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": reportingRouteNames.attribution,
          "params": [
            "location_id"
          ],
          "default_params": {
            "type": "attribution-v2"
          }
        },
        "userScopes": {
          "any": [],
          "all": [
            "reporting/attributions.readonly"
          ]
        }
      },
      {
        "name": "common.sidebar.callReporting",
        "meta": "call-reporting",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "phone_call_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": reportingRouteNames.callStats,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "reporting/phone.readonly"
          ]
        }
      },
      {
        "name": "common.sidebar.agentReporting",
        "meta": "agent-reporting",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "agent_reporting_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": reportingRouteNames.agent,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "reporting/agent.readonly"
          ]
        }
      },
      {
        "name": "common.sidebar.appointmentReport",
        "meta": "appointment-report",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [
            "appointments_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": reportingRouteNames.appointments,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "calendars.readonly",
            "calendars/events.readonly",
            "calendars/groups.readonly"
          ]
        }
      },
      {
        "name": "common.sidebar.auditReport",
        "meta": "audit-report",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": "audit-report",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      }
    ],
    "route": {
      "name": reportingRouteNames.default,
      "params": [
        "location_id"
      ]
    },
    "userScopes": {
      "any": [
        "reporting/adwords.readonly",
        "reporting/facebookAds.readonly",
        "reporting/attributions.readonly",
        "reporting/phone.readonly",
        "reporting/agent.readonly",
        "reporting/reports.write",
        "calendars.readonly",
        "calendars/events.readonly",
        "calendars/groups.readonly"
      ],
      "all": []
    }
  },
  {
    "name": "common.sidebar.appMarketplace",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "app-marketplace",
    "tooltip": "common.sidebar.appMarketplace",
    "permissions": {
      "all": [
        "integrations"
      ],
      "any": []
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/grid-01.svg",
    "children": [],
    "route": {
      "name": integrationsRouteNames.default,
      "params": [
        "location_id"
      ]
    },
    "userScopes": {
      "any": [],
      "all": [
        "native-integrations.readonly",
        "native-integrations.write"
      ]
    }
  },
  {
    "name": "common.sidebar.mobileApp",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "location-mobile-app",
    "tooltip": "location-mobile-app",
    "permissions": {
      "all": [],
      "any": []
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/phone.svg",
    "children": [],
    "route": {
      "name": mobileAppRouteNames.default,
      "params": [
        "location_id"
      ]
    },
    "userScopes": {
      "any": [],
      "all": []
    }
  },
  {
    "name": "common.sidebar.settings",
    "enabled": true,
    "children": [],
    "type": "footer",
    "meta": "settings",
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/icon_settings.svg",
    "tooltip": "common.sidebar.settings",
    "permissions": {
      "all": [],
      "any": []
    },
    "items": [
      {
        "name": "common.sidebar.myBusiness",
        "enabled": true,
        "items": [],
        "children": [],
        "type": "divider",
        "meta": "my-business",
        "icon": null,
        "permissions": {
          "all": [],
          "any": []
        },
        "tooltip": "",
        "route": null,
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.businessProfile",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "business_info",
        "tooltip": "common.sidebar.businessProfile",
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": locationSettingsRouteNames.company,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "settings.write"
          ]
        }
      },
      {
        "name": "common.sidebar.myProfile",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "profile",
        "tooltip": "common.sidebar.myProfile",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": "settings-profile-v2",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.myProfile",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "profile",
        "tooltip": "common.sidebar.myProfile",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": "profile-v2",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.companyBilling",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "saas-billing",
        "tooltip": "common.sidebar.companyBillingTooltip",
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": locationSettingsRouteNames.locationBilling.default,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "settings.write"
          ]
        }
      },
      {
        "name": "common.sidebar.elizaService",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "eliza-service",
        "tooltip": "common.sidebar.elizaService",
        "permissions": {
          "all": [
            "settings_enabled",
            "bot_service"
          ],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": "eliza-faq-v2",
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "settings.write",
            "eliza.write"
          ]
        }
      },
      {
        "name": "common.sidebar.myStaff",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "my-staff",
        "tooltip": "common.sidebar.myStaff",
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": locationSettingsRouteNames.staff.team,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "settings.write"
          ]
        }
      },
      {
        "name": "Opportunities & Pipelines",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "Opportunities-Pipelines",
        "tooltip": "Opportunities & Pipelines",
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": []
        },
        "icon": null,
        "route": {
          "name": "crm-settings",
          "params": [
            "location_id"
          ]
        },
        "children": [
          {
            "name": "Opportunities",
            "meta": "Opportunities",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "settings_enabled",
                "opportunities_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "route": {
              "name": "crm-settings",
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "settings.write",
                "opportunities.write"
              ]
            }
          },
          {
            "name": "Pipelines",
            "meta": "Pipelines",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "settings_enabled",
                "opportunities_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "route": {
              "name": locationSettingsRouteNames.pipeline,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "settings.write",
                "opportunities.write"
              ]
            }
          }
        ],
        "userScopes": {
          "any": [],
          "all": [
            "settings.write"
          ]
        }
      },
      {
        "name": "common.sidebar.businessServices",
        "enabled": true,
        "items": [],
        "children": [],
        "type": "divider",
        "meta": "business-services",
        "icon": null,
        "permissions": {
          "all": [],
          "any": []
        },
        "tooltip": "",
        "route": null,
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.automation",
        "enabled": true,
        "conditionallyShowChildren": true,
        "items": [],
        "type": "header",
        "meta": "",
        "tooltip": "common.sidebar.automation",
        "permissions": {
          "all": [
            "settings_enabled",
            "workflows_enabled"
          ],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": locationSettingsRouteNames.automation,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [
            "settings.write",
            "workflows.readonly",
            "workflows.write",
            "campaigns.readonly",
            "campaigns.write",
            "triggers.write"
          ],
          "all": [
            "settings.write"
          ]
        }
      },
      {
        "name": "common.sidebar.calendars",
        "enabled": true,
        "conditionallyShowChildren": true,
        "items": [],
        "type": "header",
        "meta": "calendars",
        "tooltip": "common.sidebar.calendars",
        "permissions": {
          "all": [
            "settings_enabled",
            "appointments_enabled"
          ],
          "any": []
        },
        "icon": null,
        "children": [
          {
            "name": "Meetings",
            "meta": "meetings",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "settings_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "route": {
              "name": locationSettingsRouteNames.calendars.default,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "settings.write"
              ]
            }
          },
          {
            "name": "Services",
            "meta": "services",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "settings_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "route": {
              "name": locationSettingsRouteNames.calendars.services,
              "params": [
                "location_id"
              ]
            },
            "badge": {
              "enable": true,
              "title": "New"
            },
            "userScopes": {
              "any": [],
              "all": [
                "settings.write"
              ]
            }
          },
          {
            "name": "common.sidebar.connections",
            "meta": "connections",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "settings_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "route": {
              "name": locationSettingsRouteNames.calendars.newConnections,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "settings.write"
              ]
            }
          },
          {
            "name": "common.sidebar.calendars",
            "meta": "calendars-default",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "settings_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "route": {
              "name": locationSettingsRouteNames.calendars.default,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "settings.write"
              ]
            }
          },
          {
            "name": "common.sidebar.preferences",
            "meta": "preferences",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "settings_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "route": {
              "name": locationSettingsRouteNames.calendars.preferences,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "settings.write"
              ]
            }
          },
          {
            "name": "common.sidebar.availability",
            "meta": "availability",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "settings_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "route": {
              "name": locationSettingsRouteNames.calendars.availability,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "settings.write"
              ]
            }
          },
          {
            "name": "common.sidebar.connections",
            "meta": "connections",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "settings_enabled"
              ],
              "any": []
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "route": {
              "name": locationSettingsRouteNames.calendars.connections,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "settings.write"
              ]
            }
          }
        ],
        "route": {
          "name": locationSettingsRouteNames.calendars.default,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "settings.write",
            "calendars.readonly",
            "calendars/events.readonly",
            "calendars/groups.readonly"
          ]
        }
      },
      {
        "name": "common.sidebar.conversationAi",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "conversation_ai_settings_v2",
        "tooltip": "common.sidebar.conversationAIV2Settings",
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": conversationAIRouteNames.conversationAISettingsV2,
          "params": [
            "location_id"
          ]
        },
        "badge": {
          "enable": true,
          "title": "New"
        },
        "userScopes": {
          "any": ["text-ai-agents.write", "text-ai-agents-dashboard.readonly"],
          "all": [
            "settings.write"
          ]
        }
      },
      {
        "name": "common.sidebar.knowledgeBase",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "knowledge-base-settings",
        "tooltip": "common.sidebar.manageKnowledgeBases",
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": []
        },
        "icon": null,
        "children": [
          {
            "name": "common.sidebar.knowledgeBaseSettings",
            "enabled": true,
            "items": [],
            "meta": "knowledge-base-settings",
            "tooltip": "knowledge-base",
            "permissions": {
              "all": [
                "settings_enabled"
              ],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": knowledgeBaseRouteNames.knowledgeBaseSettings,
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "settings.write"
              ]
            }
          }
        ],
        "route": {
          "name": knowledgeBaseRouteNames.knowledgeBaseSettings,
          "params": [
            "location_id"
          ]
        },
        "badge": {
          "enable": true,
          "title": "New"
        },
        "userScopes": {
          "any": [],
          "all": [
            "settings.write"
          ]
        }
      },
      {
        "name": "common.sidebar.aiAgents",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "ai_agent_settings",
        "tooltip": "common.sidebar.aiAgentSettings",
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": []
        },
        "icon": null,
        "children": [
          {
            "name": "Voice AI Default",
            "enabled": true,
            "items": [],
            "meta": "voice-ai-beta-default",
            "tooltip": "voice-ai",
            "permissions": {
              "all": [
                "settings_enabled"
              ],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": voiceAIRouteNames.aiAgentSettingsDefault,
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "settings.write"
              ]
            }
          },
          {
            "name": "Voice AI Edit Agent",
            "enabled": true,
            "items": [],
            "meta": "voice-ai-beta-edit-agent",
            "tooltip": "voice-ai",
            "permissions": {
              "all": [
                "settings_enabled"
              ],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": voiceAIRouteNames.aiAgentSettingsEditAgent,
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "settings.write"
              ]
            }
          }
        ],
        "route": {
          "name": voiceAIRouteNames.aiAgentSettings,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "settings.write"
          ]
        }
      },
      {
        "name": i18n.t("common.sidebar.emailServices"),
        "enabled": true,
        "meta": "location-email-services",
        "items": [
          {
            "name": i18n.t("common.sidebar.emailServices"),
            "enabled": true,
            "items": [],
            "type": "header",
            "meta": "location-email-services",
            "tooltip": "Email Services",
            "permissions": {
              "all": [
                "settings_enabled"
              ],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": locationSettingsRouteNames.emailService.default,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": [
                "settings.write"
              ]
            }
          },
          {
            "name": i18n.t("common.sidebar.dedicatedDomains"),
            "enabled": true,
            "items": [],
            "type": "header",
            "meta": "location-dedicated-domain",
            "tooltip": i18n.t("common.sidebar.dedicatedDomains"),
            "permissions": {
              "all": [],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": locationSettingsRouteNames.emailService.dedicatedDomains.default,
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": i18n.t("common.sidebar.addDomain"),
            "enabled": true,
            "items": [],
            "type": "header",
            "meta": "location-add-dedicated-domain",
            "tooltip": i18n.t("common.sidebar.addDomain"),
            "permissions": {
              "all": [],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": locationSettingsRouteNames.emailService.dedicatedDomains.addDomain,
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": i18n.t("common.sidebar.smtpSettings"),
            "enabled": true,
            "items": [],
            "type": "header",
            "meta": "location-smtp-settings",
            "tooltip": i18n.t("common.sidebar.smtpSettings"),
            "permissions": {
              "all": [],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": locationSettingsRouteNames.emailService.dedicatedDomains.domainSettings,
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": i18n.t("common.sidebar.locationOPMTrafficStatis"),
            "enabled": true,
            "items": [],
            "type": "header",
            "meta": "location-opm-traffic-stats",
            "tooltip": i18n.t("common.sidebar.locationOPMTrafficStatis"),
            "permissions": {
              "all": [],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": locationSettingsRouteNames.emailService.postmasterTools.opmTrafficStats,
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": i18n.t("common.sidebar.locationGPMTrafficStatis"),
            "enabled": true,
            "items": [],
            "type": "header",
            "meta": "location-gpm-traffic-stats",
            "tooltip": i18n.t("common.sidebar.locationGPMTrafficStatis"),
            "permissions": {
              "all": [],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": "location-gpm-traffic-stats",
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": i18n.t("common.sidebar.verifyDomain"),
            "enabled": true,
            "items": [],
            "type": "header",
            "meta": "location-verify-dedicated-domain",
            "tooltip": i18n.t("common.sidebar.verifyDomain"),
            "permissions": {
              "all": [],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": locationSettingsRouteNames.emailService.dedicatedDomains.verifyDomain,
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": i18n.t("common.sidebar.blacklistMonitorReports"),
            "enabled": true,
            "items": [],
            "type": "header",
            "meta": "blacklist-monitor-reports",
            "tooltip": i18n.t("common.sidebar.blacklistMonitorReports"),
            "permissions": {
              "all": [],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": locationSettingsRouteNames.emailService.blacklistMonitorReports,
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": []
            }
          }
        ],
        "type": "header",
        "tooltip": i18n.t("common.sidebar.emailServices"),
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": []
        },
        "icon": "",
        "children": [],
        "route": {
          "name": locationSettingsRouteNames.emailService.default,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "settings.write"
          ]
        }
      },
      {
        "name": "common.sidebar.phoneNumbers",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "phone-number",
        "tooltip": "common.sidebar.phoneNumbers",
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": locationSettingsRouteNames.phoneNumber,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "settings.write"
          ]
        }
      },
      {
        "name": i18n.t("common.sidebar.whatsApp"),
        "enabled": false,
        "hide": true,
        "items": [],
        "type": "header",
        "meta": "whatsapp",
        "tooltip": "WhatsApp",
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": locationSettingsRouteNames.whatsapp,
          "params": [
            "location_id"
          ]
        },
        "badge": {
          "enable": false,
          "title": "common.sidebar.new"
        },
        "userScopes": {
          "any": [],
          "all": [
            "settings.write"
          ]
        }
      },
      {
        "name": "common.sidebar.otherSettings",
        "enabled": true,
        "items": [],
        "children": [],
        "type": "divider",
        "meta": "other-settings",
        "icon": null,
        "permissions": {
          "all": [],
          "any": []
        },
        "tooltip": "",
        "route": null,
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.customObjects",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "objects",
        "tooltip": "common.sidebar.customObjects",
        "permissions": {
          "all": [
            "settings_enabled",
            "contacts_enabled"
          ],
          "any": [
            "custom-objects_enabled"
          ]
        },
        "icon": null,
        "children": [
          {
            "name": "",
            "meta": "custom-objects-list",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "settings_enabled",
                "contacts_enabled"
              ],
              "any": [
                "custom-objects_enabled"
              ]
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "custom-objects-list",
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "settings.write",
                "contacts.write"
              ]
            }
          },
          {
            "name": "",
            "meta": "custom-objects-create",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "settings_enabled",
                "contacts_enabled"
              ],
              "any": [
                "custom-objects_enabled"
              ]
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "custom-objects-create",
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "settings.write",
                "contacts.write"
              ]
            }
          },
          {
            "name": "",
            "meta": "custom-object-details",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "settings_enabled",
                "contacts_enabled"
              ],
              "any": [
                "custom-objects_enabled"
              ]
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "custom-object-details",
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "settings.write",
                "contacts.write"
              ]
            }
          },
          {
            "name": "",
            "meta": "custom-object-associations",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": [
                "settings_enabled",
                "contacts_enabled"
              ],
              "any": [
                "custom-objects_enabled"
              ]
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
              "name": "custom-object-associations",
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": [
                "settings.write",
                "contacts.write"
              ]
            }
          },
          {
            "name": "",
            "meta": "customize-record-modal",
            "icon": null,
            "enabled": true,
            "permissions": {
              "all": ["settings_enabled", "contacts_enabled"],
              "any": ["custom-objects_enabled"]
            },
            "items": [],
            "children": [],
            "tooltip": null,
            "type": "header",
            "route": {
             "name": "customize-record-modal",
             "params": ["location_id"]
            },
            "hide": true
          }
        ],
        "route": {
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "settings.write",
            "contacts.write"
          ]
        }
      },
      {
        "name": "common.sidebar.customFields",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "custom-fields-settings",
        "tooltip": "common.sidebar.customFields",
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": [
            "contacts_enabled",
            "marketing_enabled"
          ]
        },
        "icon": null,
        "children": [],
        "route": {
          "name": locationSettingsRouteNames.fields,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [
            "contacts.write",
            "marketing.write"
          ],
          "all": [
            "settings.write"
          ]
        }
      },
      {
        "name": "common.sidebar.customValues",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "custom-values",
        "tooltip": "common.sidebar.customValues",
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": [
            "contacts_enabled",
            "marketing_enabled"
          ]
        },
        "icon": null,
        "children": [],
        "route": {
          "name": locationSettingsRouteNames.customValues,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [
            "contacts.write",
            "marketing.write"
          ],
          "all": [
            "settings.write"
          ]
        }
      },
      {
        "name": "common.sidebar.manageScoring",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "manage-scoring",
        "tooltip": "common.sidebar.manageScoring",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": locationSettingsRouteNames.scoring,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "Domains & URL Redirects",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "domains-urlRedirects",
        "tooltip": "Domains & URL Redirects",
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": [
            "funnels_enabled",
            "websites_enabled"
          ]
        },
        "icon": null,
        "children": [{
          "name": 'common.sidebar.domains',
          "meta": "domains",
          "icon": null,
          "enabled": true,
          "permissions": {
            "all": ["settings_enabled"],
            "any": ["funnels_enabled", "websites_enabled"]
          },
          "items": [],
          "children": [],
          "tooltip": null,
          "route": {
            "name": locationSettingsRouteNames.domain,
            "params": ['location_id']
          },
          "userScopes": {
          "any": [
            "funnels.write",
            "websites.write"
          ],
          "all": [
            "settings.write"
          ]
        }
        },
        {
          "name": "common.sidebar.urlRedirects",
          "meta": "url-redirects",
          "icon": null,
          "enabled": true,
          "permissions": {
            "all": ["settings_enabled"],
            "any": ["websites_enabled", "funnels_enabled"]
            },
          "items": [],
          "children": [],
          "tooltip": null,
          "route": {
            "name": locationSettingsRouteNames.URLRedirect,
          "params": ["location_id"]
          },
          "userScopes": {
          "any": [
            "funnels.write",
            "websites.write"
          ],
          "all": [
            "settings.write"
          ]
        }
        }],
        "route": {
          "name": locationSettingsRouteNames.domain,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [
            "funnels.write",
            "websites.write"
          ],
          "all": [
            "settings.write"
          ]
        }
      },
        
      {
          "name": "common.sidebar.externalTracking",
          "meta": "external-tracking",
          "icon": null,
          "enabled": true,
          "permissions": {
            "all": ["settings_enabled"],
            "any": []
          },
          "items": [],
          "children": [],
          "tooltip": "common.sidebar.externalTracking",
          "type": "header",
          "route": {
            "name": locationSettingsRouteNames.externalTracking,
            "params": ["location_id"]
          },
          "userScopes": {
            "any": [],
            "all": [
              "settings.write"
            ]
          }
        },
      {
        "name": "common.sidebar.integrations",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "integrations",
        "tooltip": "common.sidebar.integrations",
        "permissions": {
          "all": [
            "locations_settings_integrations_enabled"
          ],
          "any": []
        },
        "icon": null,
        "children": [
          {
            "name": "common.sidebar.integrations",
            "enabled": true,
            "items": [
              {
                "name": "GBP Pages",
                "enabled": false,
                "hide": true,
                "items": [],
                "type": "header",
                "meta": "gbp-v2",
                "tooltip": "GBP Pages",
                "permissions": {
                  "all": [],
                  "any": []
                },
                "icon": null,
                "children": [],
                "route": {
                  "name": locationSettingsRouteNames.integrations.gbpPages,
                  "params": ['location_id'],
                }
              }
            ],
            "type": "header",
            "meta": "integrations-v2",
            "tooltip": "common.sidebar.integrations",
            "permissions": {
              "all": [],
              "any": [
                "settings_enabled",
                "appointments_enabled"
              ]
            },
            "icon": null,
            "children": [],
            "route": {
              "name": locationSettingsRouteNames.integrations.list,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [
                "settings.write",
                "calendars.readonly",
                "calendars/events.readonly",
                "calendars/groups.readonly"
              ],
              "all": []
            }
          },
          {
            "name": "common.sidebar.facebookFormFieldsMapping",
            "enabled": true,
            "items": [],
            "type": "header",
            "meta": "facebook-form-fields-mapping",
            "tooltip": "Facebook form fields mapping",
            "permissions": {
              "all": [],
              "any": [
                "settings_enabled"
              ]
            },
            "icon": null,
            "children": [],
            "route": {
              "name": locationSettingsRouteNames.integrations.facebook,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [
                "settings.write",
                "calendars.readonly",
                "calendars/events.readonly",
                "calendars/groups.readonly"
              ],
              "all": []
            }
          },
          {
            "name": "common.sidebar.facebookFormFieldsMapping",
            "enabled": true,
            "items": [],
            "type": "header",
            "meta": "facebook-form-fields-mapping",
            "tooltip": "Facebook form fields mapping",
            "permissions": {
              "all": [],
              "any": [
                "settings_enabled"
              ]
            },
            "icon": null,
            "children": [],
            "route": {
              "name": locationSettingsRouteNames.integrations.facebookForms,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [
                "settings.write",
                "calendars.readonly",
                "calendars/events.readonly",
                "calendars/groups.readonly"
              ],
              "all": []
            }
          },
          {
            "name": "common.sidebar.tikTokFormFieldsMapping",
            "enabled": true,
            "items": [],
            "type": "header",
            "meta": "tiktok-form-fields-mapping",
            "tooltip": "TikTok form fields mapping",
            "permissions": {
              "all": [],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": locationSettingsRouteNames.integrations.tiktok,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": "common.sidebar.linkedInFormFieldsMapping",
            "enabled": true,
            "items": [],
            "type": "header",
            "meta": "linkedin-form-fields-mapping",
            "tooltip": "LinkedIn form fields mapping",
            "permissions": {
              "all": [],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": locationSettingsRouteNames.integrations.linkedIn,
              "params": [
                "location_id"
              ]
            },
            "userScopes": {
              "any": [],
              "all": []
            }
          }
        ],
        "route": {
          "name": locationSettingsRouteNames.integrations.default,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "native-integrations.readonly",
            "native-integrations.write"
          ]
        }
      },
      {
        "name": "LC Integrations",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "lc-integrations",
        "tooltip": "LC Integrations",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": locationSettingsRouteNames.lcIntegrations.default,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": []
        },
       "showOnlyForCompanyId": LC_INTEGRATIONS_COMPANY_ID
      },
      {
        "name": "common.sidebar.privateIntegrations",
        "enabled": true,
        "items": [
          {
            "name": locationSettingsRouteNames.privateIntegrations.list,
            "enabled": true,
            "items": [],
            "type": "header",
            "meta": "sub-app-private-integration-list",
            "tooltip": "",
            "permissions": {
              "all": [],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": locationSettingsRouteNames.privateIntegrations.list,
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": locationSettingsRouteNames.privateIntegrations.appId,
            "enabled": true,
            "items": [],
            "type": "header",
            "meta": "sub-app-private-integration",
            "tooltip": "",
            "permissions": {
              "all": [],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": locationSettingsRouteNames.privateIntegrations.appId,
              "params": [
                "location_id",
                "appId"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": locationSettingsRouteNames.privateIntegrations.appIdEdit,
            "enabled": true,
            "items": [],
            "type": "header",
            "meta": "sub-app-private-integration-edit",
            "tooltip": "",
            "permissions": {
              "all": [],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": locationSettingsRouteNames.privateIntegrations.appIdEdit,
              "params": [
                "location_id",
                "appId"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": []
            }
          }
        ],
        "type": "header",
        "tooltip": "common.sidebar.privateIntegrations",
        "permissions": {
          "all": [
            "settings_enabled",
            "location_private_integrations_enabled"
          ],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": locationSettingsRouteNames.privateIntegrations.default,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "settings.write",
            "private-integration-location.readonly",
            "private-integration-location.write"
          ]
        }
      },
      {
        "name": "common.sidebar.conversationProviders",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "conversations_providers",
        "tooltip": "common.sidebar.conversationProviders",
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": locationSettingsRouteNames.conversationProviders,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "settings.write"
          ]
        }
      },
      {
        "name": "common.sidebar.tags",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "tags",
        "tooltip": "common.sidebar.tags",
        "permissions": {
          "all": [
            "contacts_enabled",
            "tags_enabled"
          ],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": locationSettingsRouteNames.tags,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "contacts.write",
            "locations/tags.write"
          ]
        }
      },
      {
        "name": "common.sidebar.labs",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "labs",
        "tooltip": "common.sidebar.labs",
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": locationSettingsRouteNames.labs,
          "params": [
            "location_id"
          ]
        },
        "badge": {
          "enable": true,
          "title": "common.sidebar.new"
        },
        "userScopes": {
          "any": [],
          "all": [
            "settings.write"
          ]
        }
      },
      {
        "name": "common.sidebar.auditLogs",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "audit-logs-location",
        "tooltip": "common.sidebar.auditLogs",
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": locationSettingsRouteNames.auditLogs,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "settings.write"
          ]
        }
      },
      {
        "name": "common.sidebar.brandBoards",
        "meta": "brand-boards",
        "icon": null,
        "enabled": false,
        "permissions": {
          "all": [
            "marketing_enabled"
          ],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "route": null,
        "reference_route": {
          "name": "brand-boards",
          "params": [
            "location_id"
          ]
        },
        "type": "header",
        "badge": {
          "enable": true,
          "title": "common.sidebar.new"
        },
        "userScopes": {
          "any": [],
          "all": [
            "marketing.write"
          ]
        }
      },
      {
        "name": "common.sidebar.customEmails",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "custom-emails-settings-v2",
        "tooltip": "common.sidebar.customEmails",
        "permissions": {
          "all": [
            "settings_enabled"
          ],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": locationSettingsRouteNames.customEmails,
          "params": [
            "location_id"
          ]
        },
        "userScopes": {
          "any": [],
          "all": [
            "settings.write"
          ]
        }
      }
    ],
    "route": {
      "name": "settings-v2",
      "params": [
        "location_id"
      ]
    },
    "userScopes": {
      "any": [],
      "all": []
    }
  }
]

const agencyNavigation: SideBarItemConfig[] = [
  ...agencyNavigationConfig,
  {
    "name": "common.sidebar.agencyDashboard",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "agency-dashboard",
    "tooltip": "common.sidebar.agencyDashboard",
    "permissions": {
      "all": [],
      "any": []
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/agency-dashboard.svg",
    "children": [
      {
        "name": "Agency Dashboard",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency_dashboard",
        "tooltip": "Agency Dashboard",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": agencyDashboardRoutes.main,
          "params": []
        },
        "hide": true,
        "userScopes": {
          "any": [],
          "all": []
        }
      }
    ],
    "route": {
      "name": agencyDashboardRoutes.default,
      "params": []
    },
    "userScopes": {
      "any": [],
      "all": []
    }
  },
  {
    "name": "common.sidebar.saaSConfigurator",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "agency-saas-configurator",
    "tooltip": "common.sidebar.saaSConfigurator",
    "permissions": {
      "all": [],
      "any": []
    },
    "icon": {
      "value": {
        "color": "var(-black)",
        "fontFamily": "Font Awesome 5 Free",
        "name": "chart-bar",
        "unicode": "f080"
      }
    },
    "children": [
      {
        "name": "Saas Dashboard",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "saas_dashboard",
        "tooltip": "SaaS Dashboard",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": saasRoutes.builderLabs,
          "params": []
        },
        "hide": true,
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "Update Plans",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "update-plans",
        "tooltip": "Update Plans",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": saasRoutes.planUpdate,
          "params": []
        },
        "hide": true,
        "userScopes": {
          "any": [],
          "all": []
        }
      }
    ],
    "route": {
      "name": saasRoutes.default,
      "params": []
    },
    "userScopes": {
      "any": [],
      "all": []
    }
  },
  {
    "name": "common.sidebar.prospecting",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "location-prospect",
    "tooltip": "common.sidebar.prospecting",
    "permissions": {
      "all": [],
      "any": []
    },
    "icon": "https://storage.googleapis.com/msgsndr/knES3eSWYIsc5YSZ3YLl/media/63d902791be71b1427bfce58.svg+xml",
    "children": [],
    "route": {
      "name": prospectingRoutes.default,
      "params": []
    },
    "badge": {
      "enable": false,
      "title": "common.sidebar.new"
    },
    "userScopes": {
      "any": [],
      "all": []
    }
  },
  {
    "name": "common.sidebar.subAccounts",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "agency-accounts",
    "tooltip": "common.sidebar.subAccounts",
    "permissions": {
      "all": [],
      "any": []
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/agency-user.svg",
    "children": [
      {
        "name": "List",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-accounts-list",
        "tooltip": "Accounts",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": subAccountRoutes.default,
          "params": []
        },
        "hide": true,
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "Map",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-accounts-add-map",
        "tooltip": "Accounts",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": subAccountRoutes.accounts.search,
          "params": []
        },
        "hide": true,
        "userScopes": {
          "any": [],
          "all": []
        }
      }
    ],
    "route": {
      "name": subAccountRoutes.default,
      "params": []
    },
    "userScopes": {
      "any": [],
      "all": []
    }
  },
  {
    "name": "common.sidebar.subAccounts",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "agency-accounts",
    "tooltip": "common.sidebar.subAccounts",
    "permissions": {
      "all": [],
      "any": []
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/agency-user.svg",
    "children": [
      {
        "name": "List",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-accounts-list",
        "tooltip": "Accounts",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": subAccountRoutes.accounts.default,
          "params": []
        },
        "hide": true,
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "Add",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-accounts-add",
        "tooltip": "Accounts",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": subAccountRoutes.accounts.default,
          "params": [
            "id"
          ]
        },
        "hide": true,
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "Map",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-accounts-add-map",
        "tooltip": "Accounts",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": subAccountRoutes.accounts.search,
          "params": []
        },
        "hide": true,
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "Details",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-accounts-details",
        "tooltip": "Accounts",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": subAccountRoutes.accounts.default,
          "params": [
            "account_id"
          ]
        },
        "hide": true,
        "userScopes": {
          "any": [],
          "all": []
        }
      }
    ],
    "route": {
      "name": "accounts",
      "params": []
    },
    "userScopes": {
      "any": [],
      "all": []
    }
  },
  {
    "name": "common.sidebar.accountSnapshots",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "agency-account-snapshots",
    "tooltip": "common.sidebar.accountSnapshots",
    "permissions": {
      "all": [],
      "any": []
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/agency-account-snapshot.svg",
    "children": [],
    "route": {
      "name": snapshotsRoutes.default,
      "params": []
    },
    "userScopes": {
      "any": [],
      "all": []
    }
  },
  {
    "name": "common.sidebar.reselling",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "agency-account-reselling",
    "tooltip": "common.sidebar.reselling",
    "permissions": {
      "all": [],
      "any": []
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/icon-reselling.svg",
    "children": [],
    "route": {
      "name": resellingRoutes.default,
      "params": []
    },
    "userScopes": {
      "any": [],
      "all": []
    }
  },
  {
    "name": "common.sidebar.addOns",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "agency-marketplace",
    "tooltip": "common.sidebar.addOns",
    "permissions": {
      "all": [],
      "any": []
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/agency-marketplace.svg",
    "children": [],
    "route": {
      "name": marketplaceRoutes.default,
      "params": []
    },
    "userScopes": {
      "any": [],
      "all": []
    }
  },
  {
    "name": "common.sidebar.affiliatePortal",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "agency-affiliate-portal",
    "tooltip": "common.sidebar.affiliatePortal",
    "permissions": {
      "all": [],
      "any": []
    },
    "icon": {
      "value": {
        "color": "var(-black)",
        "fontFamily": "Font Awesome 5 Free",
        "name": "fas fa-users",
        "unicode": "f0c0"
      }
    },
    "children": [],
    "route": {
      "name": affiliatePortalRoutes.default,
      "params": []
    },
    "userScopes": {
      "any": [],
      "all": []
    }
  },
  {
    "name": "common.sidebar.templateLibrary",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "agency-template-library",
    "tooltip": "common.sidebar.templateLibrary",
    "permissions": {
      "all": [],
      "any": []
    },
    "icon": {
      "value": {
        "color": "var(-black)",
        "fontFamily": "Font Awesome 5 Free",
        "name": "shapes",
        "unicode": "f61f"
      }
    },
    "children": [],
    "route": {
      "name": templateLibraryAdminRoutes.default,
      "params": []
    },
    "badge": {
      "enable": false,
      "title": "common.sidebar.new"
    },
    "userScopes": {
      "any": [],
      "all": []
    }
  },
  {
    "name": "common.sidebar.partners",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "agency-partners",
    "tooltip": "common.sidebar.partners",
    "permissions": {
      "all": [],
      "any": []
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/agency-partners.svg",
    "children": [
      {
        "name": "Affiliates",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-partners-affiliates",
        "tooltip": "Partners Affiliates",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": partnersRoutes.default,
          "params": []
        },
        "hide": true,
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "Affiliates List",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-partners-affiliates-list",
        "tooltip": "Partners Affiliates List",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": partnersRoutes.list,
          "params": []
        },
        "hide": true,
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "Add",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-partners-affiliates-add",
        "tooltip": "Partners Affiliates Add",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": partnersRoutes.add,
          "params": []
        },
        "hide": true,
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "Update",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-partners-affiliates-update",
        "tooltip": "Partners Affiliates Update",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": partnersRoutes.update,
          "params": [
            "id"
          ]
        },
        "hide": true,
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "Details",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-partners-affiliates-details",
        "tooltip": "Partners Affiliates Details",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": partnersRoutes.detail,
          "params": [
            "affiliate_id"
          ]
        },
        "hide": true,
        "userScopes": {
          "any": [],
          "all": []
        }
      }
    ],
    "route": {
      "name": "partners",
      "params": []
    },
    "userScopes": {
      "any": [],
      "all": []
    }
  },
  {
    "name": "common.sidebar.university",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "agency-university",
    "tooltip": "common.sidebar.university",
    "permissions": {
      "all": [],
      "any": []
    },
    "icon": {
      "value": {
        "color": "var(-black)",
        "fontFamily": "Font Awesome 5 Free",
        "name": "graduation-cap",
        "unicode": "f19d"
      }
    },
    "children": [],
    "route": {
      "name": universityRoutes.default,
      "params": []
    },
    "userScopes": {
      "any": [],
      "all": []
    }
  },
  {
    "name": "common.sidebar.saaSEducation",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "saas-education",
    "tooltip": "common.sidebar.saaSEducation",
    "permissions": {
      "all": [],
      "any": []
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/agency-saas-edu.svg",
    "children": [],
    "route": {
      "name": saasRoutes.education,
      "params": []
    },
    "userScopes": {
      "any": [],
      "all": []
    }
  },
  {
    "name": "common.sidebar.ghlSwag",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "ghl-swag",
    "tooltip": "ghl-swag",
    "permissions": {
      "all": [],
      "any": []
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/store.svg",
    "children": [],
    "route": {
      "name": ghlSwagRoutes.default,
      "params": []
    },
    "userScopes": {
      "any": [],
      "all": []
    }
  },
  {
    "name": "common.sidebar.ideas",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "agency-ideas",
    "tooltip": "common.sidebar.ideas",
    "permissions": {
      "all": [],
      "any": []
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/agency-ideas.svg",
    "children": [],
    "route": {
      "name": ideasRoutes.default,
      "params": []
    },
    "userScopes": {
      "any": [],
      "all": []
    }
  },
  {
    "name": "common.sidebar.mobileApp",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "mobile-app-customiser",
    "tooltip": "common.sidebar.mobileApp",
    "permissions": {
      "all": [],
      "any": []
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/phone.svg",
    "children": [],
    "route": {
      "name": mobileAppCustomiserRoutes.default,
      "params": []
    },
    "badge": {
      "enable": true,
      "title": "common.sidebar.new"
    },
    "userScopes": {
      "any": [],
      "all": []
    }
  },
  {
    "name": "common.sidebar.appMarketplace",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "agency-accounts",
    "tooltip": "common.sidebar.appMarketplace",
    "permissions": {
      "all": [
        "integrations"
      ],
      "any": []
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/grid-01.svg",
    "children": [],
    "route": {
      "name": integrationRoutes.default,
      "params": []
    },
    "userScopes": {
      "any": [],
      "all": [
        "native-integrations.readonly",
        "native-integrations.write"
      ]
    }
  },
  {
    "name": "common.sidebar.summerPromos",
    "enabled": true,
    "items": [],
    "type": "header",
    "meta": "summer-promos",
    "tooltip": "common.sidebar.summerPromos",
    "permissions": {
      "all": [],
      "any": []
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/gift-01.svg",
    "children": [],
    "route": {
      "name": "summer-promos",
      "params": []
    },
    "badge": {
      "enable": true,
      "title": "common.sidebar.new"
    },
    "userScopes": {
      "any": [],
      "all": []
    }
  },
  {
    "name": "common.sidebar.settings",
    "enabled": true,
    "items": [
      {
        "name": "common.sidebar.myProfile",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-profile-settings",
        "tooltip": "common.sidebar.myProfileSettings",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": settingsRoutes.default,
          "params": []
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.company",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-company-settings",
        "tooltip": "common.sidebar.companySettings",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": settingsRoutes.company,
          "params": []
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.team",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-team-settings",
        "tooltip": "common.sidebar.teamSettings",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": settingsRoutes.team,
          "params": []
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.billing",
        "enabled": true,
        "type": "header",
        "items": [],
        "meta": "agency-billing-settings",
        "tooltip": "common.sidebar.companyBilling",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": settingsRoutes.billing,
          "params": []
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.phoneIntegration",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-twilio-settings",
        "tooltip": "common.sidebar.phoneIntegrationTooltip",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": settingsRoutes.phoneIntegration,
          "params": []
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.emailServices",
        "enabled": true,
        "items": [
          {
            "name": "common.sidebar.emailServices",
            "enabled": true,
            "hide": true,
            "items": [],
            "type": "header",
            "meta": "agency-email-settings",
            "tooltip": "common.sidebar.emailServices",
            "permissions": {
              "all": [],
              "any": []
            },
            "icon": null,
            "route": {
              "name": settingsRoutes.emailService,
              "params": []
            },
            "children": [],
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": "common.sidebar.dedicatedDomains",
            "enabled": true,
            "hide": true,
            "items": [],
            "type": "header",
            "meta": "agency-dedicated-domains",
            "tooltip": "Dedicated Domains",
            "permissions": {
              "all": [],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": settingsRoutes.dedicatedDomains,
              "params": []
            },
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": "common.sidebar.addDomain",
            "enabled": true,
            "hide": true,
            "items": [],
            "type": "header",
            "meta": "agency-add-dedicated-domain",
            "tooltip": "Add Domain",
            "permissions": {
              "all": [],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": settingsRoutes.addDedicatedDomains,
              "params": []
            },
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": "common.sidebar.verifyDomain",
            "enabled": true,
            "hide": true,
            "items": [],
            "type": "header",
            "meta": "agency-verify-dedicated-domain",
            "tooltip": "Verify Domain",
            "permissions": {
              "all": [],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": settingsRoutes.verifyDedicatedDomains,
              "params": []
            },
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": "common.sidebar.locationOPMTrafficStatis",
            "enabled": true,
            "hide": true,
            "items": [],
            "type": "header",
            "meta": "agency-opm-traffic-stats",
            "tooltip": "Agency OPM Traffic Stats",
            "permissions": {
              "all": [],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": settingsRoutes.opmTrafficStats,
              "params": []
            },
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": "common.sidebar.locationGPMTrafficStatis",
            "enabled": true,
            "hide": true,
            "items": [],
            "type": "header",
            "meta": "agency-gpm-traffic-stats",
            "tooltip": "Agency GPM Traffic Stats",
            "permissions": {
              "all": [],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": settingsRoutes.gpmTrafficStats,
              "params": []
            },
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": i18n.t("common.sidebar.blacklistMonitorReports"),
            "enabled": true,
            "items": [],
            "type": "header",
            "meta": "blacklist-monitor-reports",
            "tooltip": i18n.t("common.sidebar.blacklistMonitorReports"),
            "permissions": {
              "all": [],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": settingsRoutes.blacklistMonitorReports,
              "params": [
                "location_id"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": []
            }
          }
        ],
        "type": "header",
        "meta": "agency-email-settings",
        "tooltip": "common.sidebar.emailServices",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "route": {
          "name": settingsRoutes.emailService,
          "params": []
        },
        "children": [],
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.systemEmails",
        "meta": "system-emails-setting",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": settingsRoutes.defaultEmails.default,
          "params": []
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.premiumTriggerActions",
        "meta": "workflow-premium-actions-setting",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": LOCATION_SETTING_CONFIG.workflow_premium_actions.routerName,
          "params": []
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.aiEmployee",
        "meta": "conversation-ai-setting",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": LOCATION_SETTING_CONFIG.conversationAI.routerName,
          "params": []
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.workflowAi",
        "meta": "workflow-ai-setting",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": LOCATION_SETTING_CONFIG.workflow_ai.routerName,
          "params": []
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "Domain Purchase",
        "meta": "domain-purchase-setting",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": LOCATION_SETTING_CONFIG.domainPurchase.routerName,
          "params": []
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.autoCompleteAddress",
        "meta": "auto-complete-address",
        "icon": null,
        "enabled": true,
        "permissions": {
          "all": [],
          "any": []
        },
        "items": [],
        "children": [],
        "tooltip": null,
        "type": "header",
        "route": {
          "name": LOCATION_SETTING_CONFIG.autoCompleteAddress.routerName,
          "params": []
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.privateIntegrations",
        "enabled": true,
        "items": [
          {
            "name": locationSettingsRouteNames.privateIntegrations.list,
            "enabled": true,
            "items": [],
            "type": "header",
            "meta": "sub-app-private-integration-list",
            "tooltip": "",
            "permissions": {
              "all": [],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": settingsRoutes.privateIntegrations.list,
              "params": []
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": locationSettingsRouteNames.privateIntegrations.appId,
            "enabled": true,
            "items": [],
            "type": "header",
            "meta": "sub-app-private-integration",
            "tooltip": "",
            "permissions": {
              "all": [],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": settingsRoutes.privateIntegrations.subapp,
              "params": [
                "appId"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": locationSettingsRouteNames.privateIntegrations.appIdEdit,
            "enabled": true,
            "items": [],
            "type": "header",
            "meta": "sub-app-private-integration-edit",
            "tooltip": "",
            "permissions": {
              "all": [],
              "any": []
            },
            "icon": null,
            "children": [],
            "route": {
              "name": settingsRoutes.privateIntegrations.edit,
              "params": [
                "appId"
              ]
            },
            "hide": true,
            "userScopes": {
              "any": [],
              "all": []
            }
          }
        ],
        "type": "header",
        "tooltip": "common.sidebar.privateIntegrations",
        "permissions": {
          "all": [
            "company_private_integrations_enabled"
          ],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": settingsRoutes.privateIntegrations.default,
          "params": []
        },
        "userScopes": {
          "any": [],
          "all": [
            "private-integration-company.readonly",
            "private-integration-company.write"
          ]
        }
      },
      {
        "name": "common.sidebar.affiliates",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-affiliate-settings",
        "tooltip": "Affiliate Settings",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": settingsRoutes.affiliate,
          "params": []
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.customMenuLink",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-custom-link-settings",
        "tooltip": "common.sidebar.customMenuLink",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": settingsRoutes.customMenuLink,
          "params": []
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.stripe",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-stripe-settings",
        "tooltip": "common.sidebar.stripe",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": settingsRoutes.stripe,
          "params": []
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.apiKeys",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-api-keys-settings",
        "tooltip": "common.sidebar.apiKeys",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": settingsRoutes.apiKey,
          "params": []
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.compliance",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-compliance-settings",
        "tooltip": "common.sidebar.compliance",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [
          {
            "name": "Compliance",
            "enabled": false,
            "items": [],
            "type": "header",
            "meta": "Compliance",
            "tooltip": "Compliance",
            "permissions": {
              "all": [],
              "any": []
            },
            "hide": true,
            "icon": null,
            "children": [],
            "route": {
              "name": settingsRoutes.compliance.default,
              "params": []
            },
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": "Hipaa Document",
            "enabled": false,
            "items": [],
            "type": "header",
            "meta": "agency-hipaa-document",
            "tooltip": "Agency Hipaa Document",
            "permissions": {
              "all": [],
              "any": []
            },
            "hide": true,
            "icon": null,
            "children": [],
            "route": {
              "name": settingsRoutes.compliance.hipaaDocument,
              "params": []
            },
            "userScopes": {
              "any": [],
              "all": []
            }
          },
          {
            "name": "Hipaa Detail",
            "enabled": false,
            "items": [],
            "type": "header",
            "meta": "agency-hipaa-detail",
            "tooltip": "Agency Hipaa Detail",
            "permissions": {
              "all": [],
              "any": []
            },
            "hide": true,
            "icon": null,
            "children": [],
            "route": {
              "name": settingsRoutes.compliance.hipaaDetail,
              "params": []
            },
            "userScopes": {
              "any": [],
              "all": []
            }
          }
        ],
        "route": {
          "name": settingsRoutes.compliance.default,
          "params": []
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.launchpad",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-launchpad-settings",
        "tooltip": "common.sidebar.launchpad",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": settingsRoutes.launchpad,
          "params": []
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.labs",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-labs-settings",
        "tooltip": "Company Labs",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": settingsRoutes.labs,
          "params": []
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      },
      {
        "name": "common.sidebar.auditLogs",
        "enabled": true,
        "items": [],
        "type": "header",
        "meta": "agency-audit-logs-settings",
        "tooltip": "common.sidebar.teamSettings",
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": settingsRoutes.audit,
          "params": []
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      }
    ],
    "type": "footer",
    "meta": "agency-settings",
    "tooltip": "common.sidebar.settings",
    "permissions": {
      "all": [],
      "any": []
    },
    "icon": "https://storage.googleapis.com/highlevel-backend.appspot.com/sidebar-v2/icon_settings.svg",
    "children": [],
    "route": {
      "name": settingsRoutes.default,
      "params": []
    },
    "userScopes": {
      "any": [],
      "all": []
    }
  },
  {
    "name": "share_email_template",
    "enabled": true,
    "items": [],
    "meta": "share_email_template",
    "tooltip": "share_email_template",
    "permissions": {
      "all": [],
      "any": []
    },
    "icon": "https://storage.googleapis.com/msgsndr/knES3eSWYIsc5YSZ3YLl/media/63d902791be71b1427bfce58.svg+xml",
    "children": [
      {
        "name": "share_template",
        "enabled": true,
        "items": [],
        "hide": true,
        "type": "header",
        "meta": "share_email_template",
        "tooltip": null,
        "permissions": {
          "all": [],
          "any": []
        },
        "icon": null,
        "children": [],
        "route": {
          "name": "share_email_template",
          "params": []
        },
        "userScopes": {
          "any": [],
          "all": []
        }
      }
    ],
    "route": {
      "name": "share_email_template_default",
      "params": []
    },
    "userScopes": {
      "any": [],
      "all": []
    }
  }
]

// SideBarIteConfig has been used as V2RouteConfig, 
// TODO: Remove this and use SideBarItemConfig directly after all config has been moved to config/navigation
export { Permissions, Scopes, SideBarItemConfig as V2RouteConfig, agencyNavigation, locationNavigation }
